import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import {
    apiKeyCheck, changeReserve, getCourseListFromPlan, getKenriWariate, getMealCourseList, getMealStartTimeList, getMemberRelationList, getPrefectureList, getPropertyList, getRestaurantList,
    getRoomList, getServiceCheck, getShuttleBusTimeList, getTransportList, searchZipCode, setReserve, versionGetApi, selectSaveHomeFlInfo, getRiyobiList
} from "../../../const";
import Const from "../../../const/Const";
import MessageConst from '../../../const/messageConst';
import { right } from "../../../reducers/membership_hotel/right";
import common from "../../../resources/js/common/common";
import thanks_logo from '../../../resources_membership_hotel/image/thanks_logo.gif';
import { Button } from "../../atoms/button";
import { Label } from '../../atoms/label';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { MealInputList } from "../../molecules/mealInputList";
import { RoomInputList } from "../../molecules/roomInputList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/inputUser.css';

const human = [
    { id: "0", value: "0", selected: true },
    { id: "1", value: "1", selected: false },
    { id: "2", value: "2", selected: false },
    { id: "3", value: "3", selected: false },
];

const MembershipInputUserContainer = (props) => {
    const {
        state,
        login,
        // propertyInfo,
        mealInfoList,
        setMealInfoList,
        otherMenuInfoList,
        setOtherMenuInfoList,
        membershipSearchParam,
        setMembershipSearchParam,
        membershipReserveInfo,
        setMembershipReserveInfo,
        membershipReserveComf,
        inputUserInfo,
        setInputUserInfo,
        inputRoomList,
        setInputRoomList,
        serviceCheckInfo,
        setServiceCheckInfo,
        right,
        setRight,
        setPopupData,
        setCategoryLabel,
        setPropertyInfo,
        onClickOpenPopupWindow,
        onClickOpenRoomPopup,
        setMembershipPlanInfo,
        prevScreenInfo,
        onClickOpenDescriptionHomeFlWindow,
        riyobiList,
        setRiyobiList
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    let targetIndex = 0;
    const loginUserInfo = store.getState().login.loginUserInfo;

    const loginType = login.loginType;
    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;

    /** CRAWL用ユーザー情報設定 */
    const userInfo = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;

    const resvKaiinken = store.getState().resvKaiinken;
    // const loginUserInfo = {
    //     address1: "北海道",
    //     address2: "北海道",
    //     address3: "北海道",
    //     address4: null,
    //     birthday: "1968-02-25",
    //     memberMei: "テスト",
    //     memberMeiKana: "テスト",
    //     memberSei: "太郎",
    //     memberSeiKana: "タロウ",
    //     mobileAddress: null,
    //     mobilePhone: "080-1234-5678",
    //     pcAddress: "rttest2010@rttest.jp",
    //     phone: null,
    //     sexCode: "01",
    //     zipCode: "999-9999"
    // }
    const [linkList, setLinkList] = useState([]);
    const [roomTypeList, setRoomTypeList] = useState([]);
    const [adultNumList, setAdultNumList] = useState([]);
    const [childNumList, setChildNumList] = useState([]);
    const [prefectureList, setPrefectureList] = useState([]);
    const [relationList, setRelationList] = useState([]);
    const [transportList, setTransportList] = useState([]);
    const [jikantaiKbnList, setJikantaiKbnList] = useState([]);
    const [riyoDatList, setRiyoDatList] = useState([]);
    const [inputRestaurantFlg, setInputRestaurantFlg] = useState(false);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessageBox: [], errorFlg: false, });
    const [flgList, setFlgList] = useState(false);
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: "", errorFlg: false, });

    const [illegalFlg, setIllegalFlg] = useState(false);
    const [redFlg, setRedFlg] = useState(false);
    const [usedHomeFlKenriFlg, setUsedHomeFlKenriFlg] = useState(null);
    const [familyFlg, setFamilyFlg] = useState(false);
    const [applicantName, setApplicantName] = useState("");
    const [applicantNameKana, setApplicantNameKana] = useState("");

    // rtoasterタグ生成
    const customParam = {
        "riyosyodat": membershipSearchParam.checkInDate,
        "sisetucd": membershipReserveInfo.shisetsuCd,
        "packcd": membershipReserveInfo.planCd,
        "packnam": membershipReserveInfo.planName,
        "keiyakuno": membershipSearchParam.keiyakuNo,
        "roomsu": membershipSearchParam.roomCnt,
        "hakusu": membershipSearchParam.nights,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if(state.pathSetLoading){
          return;
        }
        common.doPost(versionGetApi, {}, afterVerCheck);
        setMembershipPlanInfo(membershipReserveInfo);
        if (membershipReserveInfo.changeFlg) {
            if (loginType === 'MEMBER') {
                if (membershipReserveInfo.changeType === 'plan') {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                        { path: "/reserve/hotel/changePlan", label: "プラン変更" }
                    ]);
                } else {
                    setLinkList([
                        { path: "/reserve/top", label: "HOME" },
                        { path: "/reserve/hotel/search", label: "ホテル予約" },
                        { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" }
                    ]);
                }
            } else if (loginType === 'CRAWL') {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" }
                ]);
            }
        } else {
            if (loginType === 'MEMBER') {
                setLinkList([
                    { path: "/reserve/top", label: "HOME" },
                    { path: "/reserve/hotel/search", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" }
                ]);
            } else if (loginType === 'CRAWL') {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" }
                ]);
            }
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        if (commonUtil.checkIllegalAccess(membershipReserveInfo, membershipSearchParam)) {
            setIllegalFlg(true);
            setCategoryLabel("お客様情報入力");
        } else {
            let newRoomList = [];
            let personCountSum = {};
            if (((prevScreenInfo && (prevScreenInfo.prevPath.indexOf("hotel/chooseRight") != -1 ||
                prevScreenInfo.prevPath.indexOf("hotel/confirmUser") != -1)) || membershipReserveInfo.changeFlg) && inputUserInfo.inputRoomList) {

                newRoomList = inputUserInfo.inputRoomList;
                setInputRoomList(newRoomList);
                if (!membershipReserveInfo.generalFlg) {
                    requestGetServiceCheck(newRoomList, inputUserInfo.relationCd, inputUserInfo.applicantFlg);
                }
                // 予約変更の場合、人数合計値計算（コースの人数選択上限のため）
                if (membershipReserveInfo.changeFlg) {
                    personCountSum = getPersonCountSum(newRoomList);
                }
                const comparisonAdultCnt = membershipReserveInfo.changeFlg ? personCountSum.adultCnt : inputUserInfo.adultCnt;
                setInputRestaurantFlg(comparisonAdultCnt > 0 && comparisonAdultCnt >= membershipSearchParam.roomCnt);
            } else {
                for (let i = 0; i < membershipSearchParam.roomCnt; i++) {
                    let room = {
                        roomType: "",
                        roomTypeName: "",
                        menCnt: 0,
                        womenCnt: 0,
                        childCnt: 0,
                        preschoolerCnt: 0,
                        babyCnt: 0,
                        machiLabel: "",
                        roomDayList: []
                    }
                    newRoomList.push(room);
                }
                setInputRoomList(newRoomList);
                setServiceCheckInfo({});
            }
            if (!membershipReserveInfo.generalFlg) {
                // 空室取得
                let req = {
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    planCd: membershipReserveInfo.machiFlg != 0 ? Const.SIMPLE_STAY_PLAN_CD : membershipReserveInfo.planCd,
                    yoyakuNo: membershipReserveInfo.yoyakuNo ? membershipReserveInfo.yoyakuNo : "",
                    riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    riyoDate: membershipSearchParam.checkInDate,
                    hakuCnt: membershipSearchParam.nights,
                    machiFlg: membershipReserveInfo.machiFlg
                }
                common.doPostRef(getRoomList, req, newRoomList, afterGetRoomList);
            }
            // 会員との関係一覧取得
            common.doPost(getMemberRelationList, {}, afterGetMemberRelationList);
            // 交通機関一覧取得
            common.doPost(getTransportList, {}, afterGetTransportList);
            // プロパティ一覧取得
            common.doPost(getPropertyList, { propertyTypeList: ["SPAN_TIME"] }, afterGetPropertyList);

            let newAdultNumList = [];
            // for (let i = 0; i <= (membershipSearchParam.adultCnt < Const.MAX_ROOM_CAPACITY ? membershipSearchParam.adultCnt : Const.MAX_ROOM_CAPACITY); i++) {
            for (let i = 0; i <= Const.MAX_ROOM_CAPACITY; i++) {
                newAdultNumList.push({ id: i, value: i, selected: false });
            }
            setAdultNumList(newAdultNumList)
            let newChildNumList = [];
            // for (let i = 0; i <= (membershipSearchParam.childCnt < Const.MAX_ROOM_CAPACITY - 1 ? membershipSearchParam.childCnt : Const.MAX_ROOM_CAPACITY - 1); i++) {
            for (let i = 0; i <= Const.MAX_ROOM_CAPACITY; i++) {
                newChildNumList.push({ id: i, value: i, selected: false });
            }
            setChildNumList(newChildNumList)
            if (membershipReserveInfo.changeFlg) {
                membershipReserveInfo.changeType === 'plan'
                    ? setCategoryLabel("お客様情報入力(プラン変更)") : setCategoryLabel("お客様情報入力（人数・レストラン変更）")
            } else if (membershipReserveInfo.machiFlg && membershipReserveInfo.machiFlg != 0) {
                setCategoryLabel(membershipReserveInfo.machiFlg == "1" ? "お客様情報入力(交換待ち)" : isWidePhone ? "お客様情報入力\n(キャンセル待ち)" : "お客様情報入力(キャンセル待ち)" )
            } else {
                setCategoryLabel("お客様情報入力");
            }
            let refInputUserInfo = {}
            if (loginUserInfo) {
                if (!isCrawl) {
                    setApplicantName(`${loginUserInfo.memberSei} ${loginUserInfo.memberMei}`);
                    setApplicantNameKana(`${loginUserInfo.memberSeiKana} ${loginUserInfo.memberMeiKana}`);
                }
                let daihyouName = "";
                let daihyouNameKana = "";
                daihyouNameKana = !inputUserInfo.daihyouNameKana ? loginUserInfo.memberSeiKana + " " + loginUserInfo.memberMeiKana : inputUserInfo.daihyouNameKana;
                daihyouName = !inputUserInfo.daihyouName ? loginUserInfo.memberSei + " " + loginUserInfo.memberMei : inputUserInfo.daihyouName;
                const mainPhoneNumber = inputUserInfo.mainPhoneNumber || (loginUserInfo.mobilePhone ? loginUserInfo.mobilePhone : loginUserInfo.phone)
                const contactPhoneNumber = inputUserInfo.contactPhoneNumber || (loginUserInfo.mobilePhone ? loginUserInfo.mobilePhone : loginUserInfo.phone)
                const contactMailAddress = inputUserInfo.contactMailAddress || loginUserInfo.pcAddress
                const address1 = inputUserInfo.address1 || loginUserInfo.address2
                const address2 = inputUserInfo.address2 || loginUserInfo.address3
                const address3 = inputUserInfo.address3 || loginUserInfo.address4
                const bikoList = []
                if (membershipReserveInfo.generalFlg) {
                    // TLのみ備考に表示
                    if (membershipSearchParam.kaiinkenNo) {
                        bikoList.push(`会員番号：${membershipSearchParam.kaiinkenNo}`)
                    }
                    if (login.memberCode) {
                        bikoList.push(`ポイント番号：${login.memberCode}`)
                    }
                }
                const biko = inputUserInfo.biko || bikoList.join("、")

                refInputUserInfo = {
                    ...inputUserInfo,
                    ...personCountSum,
                    applicantName,
                    applicantNameKana,
                    daihyouNameKana,
                    daihyouName,
                    mainPhoneNumber,
                    contactPhoneNumber,
                    contactMailAddress,
                    address1,
                    address2,
                    address3,
                    biko
                }
            }
            if (isCrawl) {
                let daihyouNameKana = "";
                let daihyouName = "";
                let mainPhoneKbn = "";
                let mainPhoneNumber = "";
                let contactPhoneNumber = "";
                if (membershipReserveInfo.changeFlg) {
                    daihyouNameKana = inputUserInfo.daihyouNameKana || "";
                    daihyouName = inputUserInfo.daihyouName || "";
                    mainPhoneKbn = inputUserInfo.mainPhoneKbn || "";
                    mainPhoneNumber = inputUserInfo.mainPhoneNumber || ""
                    contactPhoneNumber = inputUserInfo.contactPhoneNumber || ""
                } else if (resvKaiinken && resvKaiinken.length) {
                    const kaiinkenObj = resvKaiinken.find(kaiinken => kaiinken.selected);
                    daihyouNameKana = !inputUserInfo.daihyouNameKana ? kaiinkenObj.kojinNamKn1 : inputUserInfo.daihyouNameKana;
                    daihyouName = !inputUserInfo.daihyouName ? kaiinkenObj.kojinNamKj1 : inputUserInfo.daihyouName;
                    mainPhoneKbn = !inputUserInfo.mainPhoneKbn ? kaiinkenObj.renrakuKbn : inputUserInfo.mainPhoneKbn;
                    mainPhoneNumber = !inputUserInfo.mainPhoneNumber ? mainPhoneKbn == "1" || mainPhoneKbn == "2" ? kaiinkenObj.telNo : "" : inputUserInfo.mainPhoneNumber;
                    contactPhoneNumber = !inputUserInfo.contactPhoneNumber ? mainPhoneKbn == "1" || mainPhoneKbn == "2" ? kaiinkenObj.telNo : "" : inputUserInfo.contactPhoneNumber;
                }

                refInputUserInfo = {
                    ...inputUserInfo,
                    ...personCountSum,
                    daihyouNameKana,
                    daihyouName,
                    mainPhoneKbn,
                    mainPhoneNumber,
                    contactPhoneNumber
                }
                document.getElementsByName("mainPhoneKbn").forEach(obj => {
                    if (obj.value == mainPhoneKbn) {
                        obj.checked = true;
                    }
                })
            }
            
            if (!membershipReserveInfo.changeFlg) {
                // TODO: 初期値設定は、テーブルからに変更する
                // 特定の施設の場合に、SCI,SCOチェックボックスに初期値を設定
                // ※暫定処理のためハードコーディング
                if (membershipReserveInfo.shisetsuCd === "301") { // サンクチュアリコート高山の場合にSCIチェックボックスに初期値を設定
                    refInputUserInfo.smartCheckInFlg = true;
                    refInputUserInfo.smartCheckOutFlg = true;
                }
            }

            // 「ホームFL優先」の値を設定
            requestSelectSaveHomeFlInfo(refInputUserInfo);

            // 家族会員権フラグを設定
            setFamilyFlgInkaiinInfoList(membershipSearchParam.keiyakuNo);
        }
    }, [useMediaFlag, state.pathSetLoading]);

    useEffect(() => {
        if (riyobiList) {
            setRedFlg(riyobiList.some(value => value.riyoDatIroKbn == "red"));
        } else {
            setRedFlg(false);
        }
    }, [riyobiList, inputUserInfo.relationCd]);

    useEffect(() => {
        const els = document.getElementsByName("usedHomeFlKenriFlg");
        if (0 < els.length) {
            els.forEach(e => {
                if (!e.checked) {
                    if (e.value === usedHomeFlKenriFlg) {
                        e.checked = true;
                        setInputUserInfo({ ...inputUserInfo, usedHomeFlKenriFlg: usedHomeFlKenriFlg });
                    }
                } else {
                    if (e.value !== usedHomeFlKenriFlg) {
                        e.checked = false;
                    }
                }
            });
        }
    }, [usedHomeFlKenriFlg]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // プロパティ一覧取得後処理
    const afterGetPropertyList = (res) => {
        let data = res.data;
        let dataList = [];
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            if (data.propertyList && data.propertyList.length != 0) {
                let propertyList = data.propertyList;
                propertyList.forEach(value => {
                    switch (value.type) {
                        // 時間帯区分
                        case "SPAN_TIME":
                            dataList.push({ jikantaiKbn: value.apiCallValue, jikantai: value.propertyValue });
                            break;
                        default:
                            break;
                    }
                })
                setJikantaiKbnList(dataList);
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })

        if (prevScreenInfo && (prevScreenInfo.prevPath.indexOf("hotel/chooseRight") != -1 ||
            prevScreenInfo.prevPath.indexOf("hotel/confirmUser") != -1) && inputUserInfo.inputMealInfoList) {
            setMealInfoList(inputUserInfo.inputMealInfoList);
        } else if (membershipReserveInfo.changeFlg && inputUserInfo.foodList) {

            // 予約変更の場合のfoodList初期設定

            // 時間帯区分
            // 夕
            const jikantaiKbnEvening = "2";
            // 朝
            const jikantaiKbnMorning = "3";

            let newMealList = [];
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "yyyy-MM-dd");
            for (let i = 1; i <= membershipSearchParam.nights + 1; i++) {
                let mealInfo = inputUserInfo.foodList.find(value => value.dayCnt == i);
                if (i > 1) {
                    const breakfastInfo = mealInfo && mealInfo.foodTimeList.find(value => value.jikantaiKbn == jikantaiKbnMorning)
                    let breakfastData = {};
                    if (breakfastInfo) {
                        let breakfastNum = 0;
                        let dispBreakfastCourse = "";
                        const breakfastCourseList = breakfastInfo.courseList ? breakfastInfo.courseList.map(value => {
                            dispBreakfastCourse += (dispBreakfastCourse == "" ? "" : "、 ") + value.foodCourseName + "：" + value.targetCnt + "人";
                            breakfastNum += value.targetCnt;
                            return { courseCd: value.foodCourseCd, courseName: value.foodCourseName, courseNum: value.targetCnt, sykjYykDataId: value.sykjYykDataId }
                        }) : [];
                        const breakfastDoiList = breakfastInfo.doiList && breakfastInfo.doiList.length > 0 ? breakfastInfo.doiList.map(doiInfo => {
                            return { doiTitle: doiInfo.doiTitle, doiSetsumei: doiInfo.doiSetsumei, doiSetsumeiURL: doiInfo.doiSetsumeiURL, checked: true }
                        }) : [];
                        breakfastData = {
                            nights: i,
                            restaurantCd: breakfastInfo.restaurantCd,
                            restaurantName: breakfastInfo.restaurantName,
                            // jikantaiKbn: dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "朝") ? dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "朝").jikantaiKbn : "3",
                            jikantaiKbn: jikantaiKbnMorning,
                            restaurantRiyoDate: dateList[i - 1],
                            mealTime: breakfastInfo.startTime,
                            selectCourseFlg: true,
                            courseList: breakfastCourseList,
                            dispCourse: dispBreakfastCourse,
                            riyoNinzuFlg: !membershipReserveInfo.breakfastTsukiPlanFlg,
                            riyoNinzu: breakfastNum,
                            adultCnt: breakfastInfo.adultCnt,
                            childCnt: breakfastInfo.childCnt,
                            preschoolerCnt: breakfastInfo.preschoolerCnt,
                            babyCnt: breakfastInfo.babyCnt,
                            doiList: breakfastDoiList,
                            required: membershipReserveInfo.breakfastTsukiPlanFlg,
                            sykjYykDataId: breakfastInfo.sykjYykDataId
                        }
                    } else {
                        breakfastData = {
                            nights: i,
                            restaurantCd: "V0",
                            restaurantName: "未定",
                            jikantaiKbn: jikantaiKbnMorning,
                            restaurantRiyoDate: dateList[i - 1],
                            mealTime: "",
                            selectCourseFlg: true,
                            courseList: [],
                            dispCourse: "",
                            riyoNinzuFlg: !membershipReserveInfo.breakfastTsukiPlanFlg,
                            riyoNinzu: "",
                            adultCnt: 0,
                            childCnt: 0,
                            preschoolerCnt: 0,
                            babyCnt: 0,
                            doiList: [],
                            required: membershipReserveInfo.breakfastTsukiPlanFlg
                        }
                    }
                    newMealList.push(breakfastData);
                }
                if (i < membershipSearchParam.nights + 1) {
                    const dinnerInfo = mealInfo && mealInfo.foodTimeList.find(value => value.jikantaiKbn == jikantaiKbnEvening)
                    let dinnerData = {}
                    if (dinnerInfo) {
                        let dinnerNum = 0;
                        let dispDinnerCourse = "";
                        const dinnerCourseList = dinnerInfo.courseList ? dinnerInfo.courseList.map(value => {
                            dispDinnerCourse += (dispDinnerCourse == "" ? "" : "、 ") + value.foodCourseName + "：" + value.targetCnt + "人";
                            dinnerNum += value.targetCnt;
                            return { courseCd: value.foodCourseCd, courseName: value.foodCourseName, courseNum: value.targetCnt, sykjYykDataId: value.sykjYykDataId }
                        }) : [];
                        const dinnerDoiList = dinnerInfo.doiList && dinnerInfo.doiList.length > 0 ? dinnerInfo.doiList.map(doiInfo => {
                            return { doiTitle: doiInfo.doiTitle, doiSetsumei: doiInfo.doiSetsumei, doiSetsumeiURL: doiInfo.doiSetsumeiURL, checked: true }
                        }) : [];
                        dinnerData = {
                            nights: i,
                            restaurantCd: dinnerInfo.restaurantCd,
                            restaurantName: dinnerInfo.restaurantName,
                            // jikantaiKbn: dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2",
                            jikantaiKbn: jikantaiKbnEvening,
                            restaurantRiyoDate: dateList[i - 1],
                            mealTime: dinnerInfo.startTime,
                            selectCourseFlg: true,
                            courseList: dinnerCourseList,
                            dispCourse: dispDinnerCourse,
                            riyoNinzuFlg: !membershipReserveInfo.dinnerTsukiPlanFlg,
                            riyoNinzu: dinnerNum,
                            adultCnt: dinnerInfo.adultCnt,
                            childCnt: dinnerInfo.childCnt,
                            preschoolerCnt: dinnerInfo.preschoolerCnt,
                            babyCnt: dinnerInfo.babyCnt,
                            doiList: dinnerDoiList,
                            required: membershipReserveInfo.dinnerTsukiPlanFlg,
                            sykjYykDataId: dinnerInfo.sykjYykDataId
                        };
                    } else {
                        dinnerData = {
                            nights: i,
                            restaurantCd: "V0",
                            restaurantName: "未定",
                            jikantaiKbn: jikantaiKbnEvening,
                            restaurantRiyoDate: dateList[i - 1],
                            mealTime: "",
                            selectCourseFlg: true,
                            courseList: [],
                            dispCourse: "",
                            riyoNinzuFlg: !membershipReserveInfo.dinnerTsukiPlanFlg,
                            riyoNinzu: "",
                            adultCnt: 0,
                            childCnt: 0,
                            preschoolerCnt: 0,
                            babyCnt: 0,
                            doiList: [],
                            required: membershipReserveInfo.dinnerTsukiPlanFlg
                        };
                    }
                    newMealList.push(dinnerData);
                }
            }
            // 対象プランのコース一覧取得
            if (membershipReserveInfo.dinnerTsukiPlanFlg || membershipReserveInfo.breakfastTsukiPlanFlg) {
                common.doPostRef(getCourseListFromPlan, {
                    keiyakuNo: membershipSearchParam.keiyakuNo,
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    planCd: membershipReserveInfo.planCd,
                    planShohinCd: membershipReserveInfo.planShohinCd,
                    riyoNinzu: (Number(membershipSearchParam.adultCnt) + Number(membershipSearchParam.childCnt)) * membershipSearchParam.roomCnt,
                    riyoDateFrom: membershipSearchParam.checkInDate,
                    riyoDateTo: membershipSearchParam.checkOutDate
                }, newMealList, afterGetCourseListFromPlan)
            } else {
                setMealInfoList(newMealList);
            }
        } else {
            let newMealList = [];
            if (!membershipReserveInfo.generalFlg && membershipReserveInfo.machiFlg == 0) {
                let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "yyyy-MM-dd");
                for (let i = 1; i <= membershipSearchParam.nights; i++) {
                    let dinnerData = {
                        nights: i,
                        restaurantCd: "",
                        restaurantName: "",
                        jikantaiKbn: dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕") ? dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "夕").jikantaiKbn : "2",
                        restaurantRiyoDate: dateList[i - 1],
                        mealTime: "",
                        selectCourseFlg: true,
                        courseList: [],
                        dispCourse: "",
                        riyoNinzuFlg: !membershipReserveInfo.dinnerTsukiPlanFlg,
                        riyoNinzu: "",
                        adultCnt: 0,
                        childCnt: 0,
                        preschoolerCnt: 0,
                        babyCnt: 0,
                        doiList: [],
                        required: membershipReserveInfo.dinnerTsukiPlanFlg
                    };
                    let breakfastData = {
                        nights: i + 1,
                        restaurantCd: "",
                        restaurantName: "",
                        jikantaiKbn: dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "朝") ? dataList.find(jikantaiInfo => jikantaiInfo.jikantai == "朝").jikantaiKbn : "3",
                        restaurantRiyoDate: dateList[i],
                        mealTime: "",
                        selectCourseFlg: true,
                        courseList: [],
                        dispCourse: "",
                        riyoNinzuFlg: !membershipReserveInfo.breakfastTsukiPlanFlg,
                        riyoNinzu: "",
                        adultCnt: 0,
                        childCnt: 0,
                        preschoolerCnt: 0,
                        babyCnt: 0,
                        doiList: [],
                        required: membershipReserveInfo.breakfastTsukiPlanFlg
                    }
                    newMealList.push(dinnerData);
                    newMealList.push(breakfastData);
                }
                // 対象プランのコース一覧取得
                if (membershipReserveInfo.dinnerTsukiPlanFlg || membershipReserveInfo.breakfastTsukiPlanFlg) {
                    common.doPostRef(getCourseListFromPlan, {
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                        planCd: membershipReserveInfo.planCd,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        riyoNinzu: (Number(membershipSearchParam.adultCnt) + Number(membershipSearchParam.childCnt)) * membershipSearchParam.roomCnt,
                        riyoDateFrom: membershipSearchParam.checkInDate,
                        riyoDateTo: membershipSearchParam.checkOutDate
                    }, newMealList, afterGetCourseListFromPlan)
                } else {
                    setMealInfoList(newMealList);
                }
            } else {
                setMealInfoList(newMealList);
            }
        }
        let hakuDateList = commonUtil.getHakuDateList(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "yyyy-MM-dd");
        setRiyoDatList(hakuDateList);
    }
    // プランコース一覧取得後処理
    const afterGetCourseListFromPlan = (res, newMealInfoList) => {
        let data = res.data
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            if (data.riyoDateJikanKbnList && data.riyoDateJikanKbnList.length != 0) {
                const newMealList = newMealInfoList.map(mealInfo => {
                    const riyoJikan = data.riyoDateJikanKbnList.find(riyoJikan =>
                        riyoJikan.restaurantRiyoDate === mealInfo.restaurantRiyoDate
                        && riyoJikan.jikantaiKbn == mealInfo.jikantaiKbn
                        && mealInfo.required
                    )
                    const riyoNinzu = membershipReserveInfo.changeFlg ? mealInfo.riyoNinzu : ((membershipSearchParam.adultCnt + membershipSearchParam.childCnt) * membershipSearchParam.roomCnt)
                    if (riyoJikan && riyoJikan.restaurantList.length == 1) {
                        const restaurant = riyoJikan.restaurantList[0]
                        let newDoiList = [];
                        if (restaurant.doiList) {
                            restaurant.doiList.forEach((doiInfo, index) => {
                                newDoiList.push({
                                    doiTitle: doiInfo.doiTitle,
                                    doiSetsumei: doiInfo.doiSetsumei,
                                    doiSetsumeiURL: doiInfo.doiSetsumeiURL,
                                    checked: mealInfo.doiList.length && mealInfo.doiList[index].checked ? true : false
                                });
                            })
                        }
                        if (membershipReserveInfo.changeFlg && membershipReserveInfo.changeType == "plan") {
                            return {
                                ...mealInfo,
                                restaurantCd: restaurant.restaurantCd,
                                restaurantName: restaurant.restaurantName,
                                selectCourseFlg: false,
                                riyoNinzu: riyoNinzu,
                                planRestaurantList: riyoJikan.restaurantList,
                                doiList: newDoiList,
                                courseList: [],
                                dispCourse: "",
                                mealTime: "",
                            }
                        } else {
                            return {
                                ...mealInfo,
                                restaurantCd: restaurant.restaurantCd,
                                restaurantName: restaurant.restaurantName,
                                selectCourseFlg: false,
                                riyoNinzu: riyoNinzu,
                                planRestaurantList: riyoJikan.restaurantList,
                                doiList: newDoiList
                            }
                        }
                    } else if (riyoJikan && riyoJikan.restaurantList.length > 1) {
                        const restaurantCd = mealInfo.restaurantCd;
                        if (restaurantCd == "V0" || restaurantCd == "89" || restaurantCd == "88") {
                            return {
                                ...mealInfo,
                                restaurantCd: "",
                                restaurantName: "",
                                selectCourseFlg: false,
                                planRestaurantList: riyoJikan.restaurantList,
                                riyoNinzu: riyoNinzu,
                            }
                        } else {
                            return {
                                ...mealInfo,
                                selectCourseFlg: false,
                                planRestaurantList: riyoJikan.restaurantList,
                                riyoNinzu: riyoNinzu,
                            }
                        }
                    } else {
                        const restaurantCd = mealInfo.restaurantCd;
                        if (restaurantCd == "V0" || restaurantCd == "89" || restaurantCd == "88") {
                            return {
                                ...mealInfo,
                                restaurantCd: "",
                                restaurantName: "",
                            }
                        } else {
                            return mealInfo
                        }
                    }
                })
                setMealInfoList(newMealList);
            } else {
                setMealInfoList(newMealInfoList);
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
            setMealInfoList(newMealInfoList);
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    //部屋タイプ情報取得後処理
    const afterGetRoomList = (res, refRoomList) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            let newRoomTypeList = data.roomList;
            let machiMongon = "";
            // 前回選んでいた部屋は選べるようにする（部屋数が減少して表示されていないとしても）
            if (membershipReserveInfo.changeFlg && membershipReserveComf.roomList != null) {
                newRoomTypeList.forEach(nr => {
                    const existsInPrevRooms = membershipReserveComf.roomList.some(r => r.roomType === nr.roomTypeCd);
                    if (existsInPrevRooms) {
                        nr.hikasseiFlg = false;
                        nr.roomSelectMax++;
                    }
                })
            }

            if((membershipReserveInfo.machiFlg === '1' || membershipReserveInfo.machiFlg === '2') && membershipSearchParam.roomType){
                const targetRoom = newRoomTypeList.find(roomInfo => roomInfo.roomTypeCd == membershipSearchParam.roomType);
                if(targetRoom){
                    const targetDay = targetRoom.roomDayList.filter(room => {
                        return room.zanRoom !== 0;
                    })
                    if(membershipReserveInfo.machiFlg === '1'){
                        if(targetDay.length !== 0){
                            machiMongon = '一部交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                        } else{
                            machiMongon = '交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                        }
                    }else if(membershipReserveInfo.machiFlg === '2'){
                        if(targetDay.length !== 0){
                            machiMongon = "一部キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。";
                        }else{
                            machiMongon = 'キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                        }
                    }
                    setInputUserInfo({...inputUserInfo, machiMongon: machiMongon});
                }
            }
        
            if (membershipSearchParam.roomType) {
                refRoomList.forEach(room => {
                    room.roomType = membershipSearchParam.roomType;
                    const targetRoom = newRoomTypeList.find(roomInfo => roomInfo.roomTypeCd == membershipSearchParam.roomType)
                    room.roomTypeName = targetRoom?.hyojiyoRoomTypeNam;
                    room.roomDayList = targetRoom?.roomDayList;

                    if (membershipReserveInfo.machiFlg != "0" && membershipSearchParam.nights > 1 && targetRoom?.roomDayList?.length) {
                        const targetList = targetRoom.roomDayList.filter(value => value.zanRoom !== 0);
                        if (targetList.length === 0) {
                            room.machiLabel = "※全日空きなし";
                        } else if (targetList.length < targetRoom.roomDayList.length) {
                            room.machiLabel = "※一部空きあり";
                        } else {
                            room.machiLabel = "";
                        }
                    }
                })
                if (inputUserInfo?.relationCd) {
                    requestGetServiceCheck(refRoomList, inputUserInfo.relationCd, inputUserInfo.applicantFlg);
                }
            }
            setRoomTypeList(newRoomTypeList);
            setInputRoomList(refRoomList);
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 都道府県一覧取得後処理
    const afterGetPrefectureList = (res, refInputUserInfo) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setPrefectureList(commonUtil.getSelectList(data.prefectureList, "prefectureCd", "prefectureName", true, "選択する"));
            if (loginUserInfo && !inputUserInfo.prefectureCd) {
                const prefecture = data.prefectureList.find(prefecture => prefecture.prefectureName === loginUserInfo.address1)
                if (prefecture) {
                    setInputUserInfo({
                        ...refInputUserInfo,
                        prefectureCd: prefecture.prefectureCd
                    })
                }
            }
            if (isCrawl && !inputUserInfo.prefectureCd) {
              let prefectureCd = '';
              if (resvKaiinken && resvKaiinken.length) {
                    const kaiinkenObj = resvKaiinken.find(kaiinken => kaiinken.selected);

                    if (kaiinkenObj && kaiinkenObj.jitakuAddKj1) {
                        const pref2 = kaiinkenObj.jitakuAddKj1.slice(0, 2);
                        const pref = data.prefectureList.find((v) => v.prefectureName.indexOf(pref2) === 0);
                        prefectureCd = pref ? pref.prefectureCd : '';
                    }
                }
                setInputUserInfo({
                    ...refInputUserInfo,
                    prefectureCd: prefectureCd,
                })
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 会員との関係一覧取得後処理
    const afterGetMemberRelationList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setRelationList(commonUtil.getSelectList(data.relationList, "relationCd", "relationName", true, "選択する"));
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 交通機関一覧取得後処理
    const afterGetTransportList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setTransportList(commonUtil.getSelectList(data.transportList, "transportCd", "transportName", true, "選択する"));
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // サービスチェック取得処理
    const requestGetServiceCheck = (roomListParam, relation, applicantFlg) => {
        // 予約部屋数取得
        const roomTypeCdList = [];
        let roomTypeSelected = true;
        roomListParam.forEach(value => {
            const roomType = value.roomType;
            if (roomType === "") {
                // 未選択時はListに追加しない
                roomTypeSelected = false;
                return;
            }
            const roomTypeCd = roomTypeCdList.find(x => x.roomTypeCd === roomType);
            if (roomTypeCd) {
                roomTypeCd.yoyakuRoomSu += 1;
            } else {
                roomTypeCdList.push({
                    roomTypeCd: roomType,
                    yoyakuRoomSu: 1
                });
            }
        });
        if (!roomTypeSelected || relation === "") {
            // お部屋タイプ、続柄が未選択時はAPIを呼び出さない
            setServiceCheckInfo({});
            return;
        }
        // サービスチェック取得
        const req = {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            riyoDate: membershipSearchParam.checkInDate,
            hakuCnt: membershipSearchParam.nights,
            tsuzukigaraCd: relation,
            roomTypeList: roomTypeCdList,
            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
            pointKaiinId: login.memberCode,
            applicantFlg: applicantFlg
        }
        common.doPostRef(getServiceCheck, req, roomListParam, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res, roomListParam) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
                sciKanoFlg: data.sciKanoFlg,
                sciKiyakuMongon: data.sciMongon,
                scoKanoFlg: data.scoKanoFlg,
                scoKiyakuMongon: data.scoMongon,
                nonstopCheckInKanoFlg: data.nonstopCheckinKanoFlg,
                nonstopKiyakuMongon: data.nonstopMongon,
                kenrishokaYoFlg: data.kenrishokaYoFlg,
                homeFlKanoFlg: data.homeFlKanoFlg
            });
            if ( !membershipReserveInfo.thanksFlg && membershipReserveInfo.machiFlg !== "2" && data.kenrishokaYoFlg === "1") {
                requestGetRiyobiList();
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 権利自動割当取得処理
    const requestGetKenriWariate = (roomListParam, newInputUserInfo) => {
        // 予約部屋数取得
        const roomTypeCdList = []
        roomListParam.forEach(value => {
            let roomType = value;
            if (roomType === "") {
                // 未選択時はListに追加しない
                return;
            }
            roomTypeCdList.push(roomType);
        });
        if (roomTypeCdList.length == roomListParam.length) {
            let req = {
                keiyakuNo: membershipSearchParam.keiyakuNo,
                shisetsuCd: membershipReserveInfo.shisetsuCd,
                riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                usedHomeFlKenriFlg: usedHomeFlKenriFlg,
                riyoFirstDat: membershipSearchParam.checkInDate,
                roomTypeCdList: roomTypeCdList,
                hakuCnt: commonUtil.getNights(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "-")
            }
            common.doPostRef(getKenriWariate, req, newInputUserInfo, afterGetKenriWariate);
        }
    }

    // 利用日一覧当取得処理
    const requestGetRiyobiList = () => {
        let req = {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
            usedHomeFlKenriFlg: usedHomeFlKenriFlg,
            riyoFirstDat: membershipSearchParam.checkInDate,
            hakuCnt: commonUtil.getNights(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "-")
        }
        common.doPost(getRiyobiList, req, afterGetRiyobiList);
    };

    // 利用日一覧当取得後処理
    const afterGetRiyobiList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
           setRiyobiList(data.riyoDatList);
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }

        setTemporaryErrorInfo({
            errorMessage: errorMessage,
            errorFlg: errorFlg
        });
    };

    // 権利自動割当取得後処理
    const afterGetKenriWariate = (res, newInputUserInfo) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            let selectRightFlgEle = document.getElementsByName("selectRightFlg");
            let selectRightFlg = selectRightFlgEle.length != 0 ? selectRightFlgEle[0].checked : "";
            if (newInputUserInfo && selectRightFlg) {
                setRight([]);
                history.push("/reserve/hotel/chooseRight");
            } else {
                let reqShokaKenriList = [];
                const riyoDatList = data.riyoDatList || [];
                if (selectRightFlgEle.length === 0 && !riyoDatList.length) {
                    setRight([]);
                } else {
                    let stayList = [];
                    riyoDatList.forEach((value, index) => {
                        let senyuDateList = [];
                        value.senyuDatList.forEach(senyuDat => {
                            senyuDateList.push({
                                shokaKenriIro: senyuDat.iroKbn,
                                shokaKenriDate: senyuDat.senyuDat,
                                senyuDatHyojiOkFlg: senyuDat.senyuDatHyojiOkFlg,
                                senyuDatHyojiDaitaiStr: senyuDat.senyuDatHyojiDaitaiStr })
                        })
                        stayList.push({
                            senyuDatHyojiOkFlg: value.senyuDatHyojiOkFlg,
                            senyuDatHyojiDaitaiStr: value.senyuDatHyojiDaitaiStr,
                            senyuDate: senyuDateList,
                            senyuKenriIro: value.riyoDatIroKbn,
                            siyoDate: value.riyoDat,
                            stayNum: index + 1
                        });
                    })
                    setRight(stayList);
                    stayList.forEach(senyu => {
                        let reqSenyuDate = [];
                        senyu.senyuDate.forEach(shoka => {
                            reqSenyuDate.push(shoka.shokaKenriDate);
                        })
                        reqShokaKenriList.push({ senyuDate: reqSenyuDate, siyoDate: senyu.siyoDate });
                    })
                }
                let req = {}
                if (membershipReserveInfo.changeFlg) {
                    req = {
                        shisetsuCd: membershipReserveInfo.shisetsuCd,
                        yoyakuNo: membershipReserveInfo.yoyakuNo,
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                        pointKaiinId: membershipSearchParam.memberCd,
                        riyoDate: membershipSearchParam.checkInDate,
                        hakuCnt: membershipSearchParam.nights,
                        planCd: membershipReserveInfo.planCd,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                        foodRequest: newInputUserInfo.foodRequest,
                        allergyKbn: newInputUserInfo.allergyKbn,
                        allergyBiko: newInputUserInfo.allergyBiko,
                        applicantNameKana: newInputUserInfo.applicantNameKana,
                        applicantName: newInputUserInfo.applicantName,
                        daihyouNameKana: newInputUserInfo.daihyouNameKana,
                        daihyouName: newInputUserInfo.daihyouName,
                        mainPhoneKbn: newInputUserInfo.mainPhoneKbn,
                        mainPhoneNumber: newInputUserInfo.mainPhoneNumber,
                        contactPhoneNumber: newInputUserInfo.contactPhoneNumber,
                        contactMailAddress: newInputUserInfo.contactMailAddress,
                        relationCd: newInputUserInfo.relationCd,
                        prefectureCd: newInputUserInfo.prefectureCd,
                        prefecture: newInputUserInfo.prefecture,
                        zipCode1: newInputUserInfo.zipCode1,
                        zipCode2: newInputUserInfo.zipCode2,
                        address1: newInputUserInfo.address1,
                        address2: newInputUserInfo.address2,
                        address3: newInputUserInfo.address3,
                        transportCd: newInputUserInfo.transportCd,
                        carCnt: newInputUserInfo.carCnt,
                        busTime: newInputUserInfo.busTime,
                        kozafurikaeFlg: newInputUserInfo.kozafurikaeFlg,
                        smartCheckInFlg: newInputUserInfo.smartCheckInFlg,
                        smartCheckOutFlg: newInputUserInfo.smartCheckOutFlg,
                        nonstopCheckInFlg: newInputUserInfo.nonstopCheckInFlg,
                        biko: newInputUserInfo.biko,
                        kakuninMailKiboKbn: newInputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                        kakuninMailAddress: newInputUserInfo.confirmReserveMail,
                        machiFlg: newInputUserInfo.machiFlg,
                        roomList: newInputUserInfo.roomList,
                        foodList: newInputUserInfo.foodList,
                        foodCourseList: newInputUserInfo.foodCourseList,
                        shokaKenriList: reqShokaKenriList,
                        dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                        breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                        thanksFlg: membershipReserveInfo.thanksFlg,
                        registFlg: false,
                        applicantFlg: newInputUserInfo.applicantFlg,
                        userInfo,
                    }

                    common.doPost(changeReserve, req, afterSetReserve);
                } else {
                    // const mealFlg = membershipReserveInfo.planCd &&
                    //     (membershipReserveInfo.breakfastTsukiPlanFlg || membershipReserveInfo.dinnerTsukiPlanFlg || membershipReserveInfo.thanksFlg ||
                    //     membershipReserveInfo?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE);
                    req = {
                        shisetsuCd: membershipReserveInfo.shisetsuCd,
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                        pointKaiinId: membershipSearchParam.memberCd,
                        riyoDate: membershipSearchParam.checkInDate,
                        hakuCnt: membershipSearchParam.nights,
                        planCd: membershipReserveInfo.planCd,
                        // planCd: mealFlg ? membershipReserveInfo.planCd : null,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                        foodRequest: newInputUserInfo.foodRequest,
                        allergyKbn: newInputUserInfo.allergyKbn,
                        allergyBiko: newInputUserInfo.allergyBiko,
                        applicantNameKana: newInputUserInfo.applicantNameKana,
                        applicantName: newInputUserInfo.applicantName,
                        daihyouNameKana: newInputUserInfo.daihyouNameKana,
                        daihyouName: newInputUserInfo.daihyouName,
                        mainPhoneKbn: newInputUserInfo.mainPhoneKbn,
                        mainPhoneNumber: newInputUserInfo.mainPhoneNumber,
                        contactPhoneNumber: newInputUserInfo.contactPhoneNumber,
                        contactMailAddress: newInputUserInfo.contactMailAddress,
                        relationCd: newInputUserInfo.relationCd,
                        prefectureCd: newInputUserInfo.prefectureCd,
                        prefecture: newInputUserInfo.prefecture,
                        zipCode1: newInputUserInfo.zipCode1,
                        zipCode2: newInputUserInfo.zipCode2,
                        address1: newInputUserInfo.address1,
                        address2: newInputUserInfo.address2,
                        address3: newInputUserInfo.address3,
                        transportCd: newInputUserInfo.transportCd,
                        carCnt: newInputUserInfo.carCnt,
                        busTime: newInputUserInfo.busTime,
                        kozafurikaeFlg: newInputUserInfo.kozafurikaeFlg,
                        smartCheckInFlg: newInputUserInfo.smartCheckInFlg,
                        smartCheckOutFlg: newInputUserInfo.smartCheckOutFlg,
                        nonstopCheckInFlg: newInputUserInfo.nonstopCheckInFlg,
                        biko: newInputUserInfo.biko,
                        kakuninMailKiboKbn: newInputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                        kakuninMailAddress: newInputUserInfo.confirmReserveMail,
                        machiFlg: newInputUserInfo.machiFlg,
                        roomList: newInputUserInfo.roomList,
                        foodList: newInputUserInfo.foodList,
                        foodCourseList: newInputUserInfo.foodCourseList,
                        shokaKenriList: reqShokaKenriList,
                        importedFlg: membershipReserveInfo.generalFlg,
                        dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                        breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                        thanksFlg: membershipReserveInfo.thanksFlg,
                        registFlg: false,
                        applicantFlg: newInputUserInfo.applicantFlg,
                        userInfo,
                    }

                    common.doPost(setReserve, req, afterSetReserve);
                }
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({
            errorMessage: errorMessage,
            errorFlg: errorFlg
        })
    }

    // 保存した「ホームFLの利用」の値取得処理
    const requestSelectSaveHomeFlInfo = (refInputUserInfo) => {
        const req = {
            memberCode: membershipSearchParam.memberCd,
            membershipNo: membershipSearchParam.kaiinkenNo,
        }
        common.doPostRef(selectSaveHomeFlInfo, req, refInputUserInfo, afterSelectSaveHomeFlInfo);
    };

    // 保存した「ホームFLの利用」の値取得後処理
    const afterSelectSaveHomeFlInfo = (res, refInputUserInfo) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            if (refInputUserInfo && !refInputUserInfo.selectRightFlg) {
                if (refInputUserInfo.usedHomeFlKenriFlg) {
                    // ローカルストレージを優先
                    setUsedHomeFlKenriFlg(refInputUserInfo.usedHomeFlKenriFlg);
                } else {
                    // ローカルストレージを優先
                    if (data.usedHomeFlKenriFlg) {
                        // 入力情報に保存
                        refInputUserInfo.usedHomeFlKenriFlg = data.usedHomeFlKenriFlg;
                        setUsedHomeFlKenriFlg(data.usedHomeFlKenriFlg);
                    } else {
                        setUsedHomeFlKenriFlg(null);
                    }
                }
            } else {
                // 手動で選択していた場合
                refInputUserInfo.usedHomeFlKenriFlg = null;
                setUsedHomeFlKenriFlg(null);
            }
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
            if (refInputUserInfo && !refInputUserInfo.selectRightFlg) {
                if (refInputUserInfo.usedHomeFlKenriFlg) {
                    setUsedHomeFlKenriFlg(refInputUserInfo.usedHomeFlKenriFlg);
                }
            }
        }

        // 都道府県取得
        common.doPostRef(getPrefectureList, {}, refInputUserInfo, afterGetPrefectureList);

        // エラー内容を設定
        setTemporaryErrorInfo({
            errorMessage: errorMessage,
            errorFlg: errorFlg
        });
    };

    // レストラン一覧取得後処理
    const afterGetRestaurantList = (res, ref) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            if (ref.changeFlg && ref.restaurantCd) {
                data.restaurantList.forEach(value => {
                    if (value.restaurantCd == ref.restaurantCd) {
                        value.mansekiFlg = false;
                    }
                })
            }
            setPopupData({
                dinnerTsukiPlanFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                breakfastTsukiPlanFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                restaurantList: data.restaurantList,
                jikantaiKbnList: jikantaiKbnList,
                targetIndex: ref.targetIndex
            })
            onClickOpenPopupWindow(ref.mode, ref.targetIndex);
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // レストランポップアップ表示
    const onClickRestaurant = (mode, index) => {
        targetIndex = index;
        let req = {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            planCd: membershipReserveInfo.planCd,
            planShohinCd: membershipReserveInfo.planShohinCd,
            riyoDate: mealInfoList[index].restaurantRiyoDate,
            jikantai: mealInfoList[index].jikantaiKbn,
            riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt,
        }
        let ref = {};
        if (membershipReserveInfo.changeFlg && inputUserInfo.foodList) {
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[index].restaurantRiyoDate, "yyyy-MM-dd");
            let dayCnt = dateList.length;
            const foodTimeList = inputUserInfo.foodList.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
            const foodTimeInfo = foodTimeList.find(value => value.jikantaiKbn == mealInfoList[index].jikantaiKbn)
            if (foodTimeInfo) {
                ref = {
                    changeFlg: true,
                    mode: mode,
                    targetIndex: index,
                    restaurantCd: foodTimeInfo.restaurantCd
                }
            } else {
                ref = {
                    changeFlg: false,
                    mode: mode,
                    targetIndex: index,
                }
            }
        } else {
            ref = {
                changeFlg: false,
                mode: mode,
                targetIndex: index,
            }
        }
        common.doPostRef(getRestaurantList, req, ref, afterGetRestaurantList);
    }

    // 同意情報表示
    const onClickDoiTitle = (mealIndx, doiIndex) => {
        let doiInfo = mealInfoList[mealIndx].doiList[doiIndex]
        setPopupData({
            doiInfo: doiInfo,
        });
        onClickOpenPopupWindow("doiInfo");
    }

    // サービス情報表示
    const onClickServiceLink = (serviceTitle, serviceText) => {
        setPopupData({
            serviceInfo: {
                serviceTitle: serviceTitle,
                serviceText: serviceText
            }
        });
        onClickOpenPopupWindow("serviceInfo");
    }

    // 利用人数ポップアップ表示
    const onClickRiyoNinzu = (mode, index) => {
        setPopupData({
            targetIndex: index,
        });
        onClickOpenPopupWindow(mode, index);
    }

    // 食事開始時間一覧取得後処理
    const afterGetMealStartTimeList = (res, ref) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            if (ref.changeFlg && ref.mealTime) {
                let startTimeList = data.startTimeList || []
                startTimeList.forEach(value => {
                    if (value.startTime == ref.mealTime) {
                        value.akiFlg = true;
                    } 
                });
                setPopupData({
                    targetIndex: ref.targetIndex,
                    selectTimeList: startTimeList
                });
            } else {
                setPopupData({
                    targetIndex: ref.targetIndex,
                    selectTimeList: data.startTimeList
                });
            }
            onClickOpenPopupWindow(ref.mode, ref.targetIndex);
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 食事開始時間ポップアップ表示
    const onClickMealTime = (mode, index) => {
        let req = {
            honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            restaurantCd: mealInfoList[index].restaurantCd,
            restaurantName: mealInfoList[index].restaurantName,
            riyoDate: mealInfoList[index].restaurantRiyoDate,
            jikantaiKbn: mealInfoList[index].jikantaiKbn,
            riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt,
        }
        let ref = {};
        if (membershipReserveInfo.changeFlg && inputUserInfo.foodList) {
            // 変更の場合かつ既に選択済みの時間がある場合は値を引き継ぐ
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[index].restaurantRiyoDate, "yyyy-MM-dd");
            let dayCnt = dateList.length;
            const foodTimeList = inputUserInfo.foodList.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
            const foodTimeInfo = foodTimeList.find(value => value.jikantaiKbn == mealInfoList[index].jikantaiKbn)
            if (foodTimeInfo) {
                ref = {
                    changeFlg: true,
                    mode: mode,
                    targetIndex: index,
                    mealTime: foodTimeInfo.startTime
                }
            } else {
                ref = {
                    changeFlg: false,
                    mode: mode,
                    targetIndex: index,
                }
            }
            common.doPostRef(getMealStartTimeList, req, ref, afterGetMealStartTimeList);
        } else {
            ref = {
                changeFlg: false,
                mode: mode,
                targetIndex: index,
            }
            common.doPostRef(getMealStartTimeList, req, ref, afterGetMealStartTimeList);
        }
    }

    // 食事コース一覧取得後処理
    const afterGetMealCourseList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setPopupData({
                targetIndex: targetIndex,
                courseList: data.courseList
            });
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 食事コースポップアップ表示
    const onClickCourse = (mode, index) => {
        targetIndex = index;
        const planRestaurantList = mealInfoList[index].planRestaurantList ? mealInfoList[index].planRestaurantList : [];
        if (planRestaurantList.length > 0) {
            const targetRestaurant = planRestaurantList.find(value => value.restaurantCd == mealInfoList[index].restaurantCd);
            setPopupData({
                targetIndex: targetIndex,
                courseList: targetRestaurant.courseList
            });
        } else {
            let req = {
                honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                shisetsuCd: membershipReserveInfo.shisetsuCd,
                restaurantCd: mealInfoList[index].restaurantCd,
                riyoDate: mealInfoList[index].restaurantRiyoDate,
                jikantaiKbn: mealInfoList[index].jikantaiKbn
            }
            common.doPost(getMealCourseList, req, afterGetMealCourseList);
            setPopupData({
                targetIndex: targetIndex,
                courseList: []
            });
        }
        onClickOpenPopupWindow(mode, index);
    }

    // シャトルバス時刻情報取得後処理
    const afterGetShuttleBusTimeList = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            setPopupData({
                landing: "テスト乗り場", // 定数仮設定
                selectTimeList: data.busSelectTimeList,
            })
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // シャトルバス時刻情報取得
    const onClickShuttleBusTime = (mode) => {
        let req = {
            honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
            riyoDate: membershipSearchParam.checkInDate,
            riyoNinzu: (Number(membershipSearchParam.adultCnt) + Number(membershipSearchParam.childCnt)) * membershipSearchParam.roomCnt,
            jikantaiKbn: "1"
        }
        common.doPost(getShuttleBusTimeList, req, afterGetShuttleBusTimeList);
        onClickOpenPopupWindow(mode);
    }

    // 住所検索後処理
    const afterSearchZipCode = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.returnCode == 0) {
            let addressList = data.body ? data.body.addressList : [];
            let newInputUserInfo = { ...inputUserInfo };
            if (addressList.length > 0) {
                let addressInfo = addressList[0]
                let prefectureCd = addressInfo.address1 && prefectureList.find(value => value.value == addressInfo.address1) ? prefectureList.find(value => value.value == addressInfo.address1).id : "";
                newInputUserInfo.prefectureCd = prefectureCd;
                newInputUserInfo.address1 = addressInfo.address2 ? addressInfo.address2 : "";
                newInputUserInfo.address2 = addressInfo.address3 ? addressInfo.address3 : "";
            }
            setInputUserInfo(newInputUserInfo);
        } else {
            // 一時エラー表示
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 住所検索
    const onClickSearchAddress = () => {
        let reqZipCode = document.getElementById("zipCode1").value + "-" + document.getElementById("zipCode2").value;
        if (reqZipCode.length == 8) {
            let req = {
                zipCode: reqZipCode
            }
            common.doPost(searchZipCode, req, afterSearchZipCode);
        }
    }

    // 会員様との関係変更
    const onChangeRelation = () => {
        let relation = document.getElementById("relation").value;
        let applicantFlg = null;
        let applicantFlgEle = document.getElementsByName("applicantFlg");
        if (applicantFlgEle.length != 0) {
            applicantFlg = applicantFlgEle[0].checked;
        }
        setInputUserInfo({ ...inputUserInfo, relationCd: relation });
        if (!membershipReserveInfo.generalFlg) {
            requestGetServiceCheck(inputRoomList, relation, applicantFlg);
        }
    }

    // ホームFL利用フラグ変更
    const onChangeUsedHomeFlKenriFlg = () => {
        // ホームFLを優先するか否かを設定
        const list = document.getElementsByName("usedHomeFlKenriFlg");
        list.forEach(value => {
            if (value.checked) {
                setUsedHomeFlKenriFlg(value.value);
            }
        });
    }

    // 予約者本人フラグ変更
    const onChangeApplicantFlg = () => {
        let newInputUserInfo = { ...inputUserInfo };
        const daihyouNameEl = document.getElementById("daihyouName");
        const daihyouNameKanaEl = document.getElementById("daihyouNameKana");
        const list = document.getElementsByName("applicantFlg");
        let changeValue = false;
        list.forEach(value => {
            if (value.checked) {
                changeValue = JSON.parse(value.value.toLowerCase());
                if (changeValue) {
                    // 代表者名を上書き
                    const daihyouName = loginUserInfo.memberSei + " " + loginUserInfo.memberMei;
                    if (daihyouNameEl) {
                        newInputUserInfo.daihyouName = daihyouName;
                        daihyouNameEl.value = daihyouName;
                    }
                    // 代表者名(カナ)を上書き
                    const daihyouNameKana = loginUserInfo.memberSeiKana + " " + loginUserInfo.memberMeiKana;
                    newInputUserInfo.daihyouNameKana = daihyouNameKana;
                    if (daihyouNameKanaEl) {
                        newInputUserInfo.daihyouNameKana = daihyouNameKana;
                        daihyouNameKanaEl.value = daihyouNameKana;
                    }
                    // 会員様とのご関係を「本人」に上書き
                    newInputUserInfo.relationCd = familyFlg ? "" : relationList.find(relationInfo => relationInfo.value == "会員本人").id;
                } else {
                    // 空文字に上書き
                    newInputUserInfo.relationCd = "";
                }
        
                if (!membershipReserveInfo.generalFlg) {
                    requestGetServiceCheck(inputRoomList, newInputUserInfo.relationCd, changeValue);
                }
            }
        });

        setInputUserInfo({...newInputUserInfo, applicantFlg: changeValue});
    };

    // 交通機関変更
    const onChangeTransport = () => {
        let transport = document.getElementById("transport").value;
        setInputUserInfo({ ...inputUserInfo, transportCd: transport })
    }

    // アレルギー有無変更
    const onChangeAllergyInfo = () => {
        let allergyExistenceList = document.getElementsByName("allergyExistence");
        let allergyExistence = "";
        allergyExistenceList.forEach(value => {
            if (value.checked) {
                allergyExistence = value.value;
            }
        })
        setInputUserInfo({ ...inputUserInfo, allergyKbn: allergyExistence, allergyBiko: "" })
    }

    // 部屋人数変更
    const onChangeHumanNum = (id, targetIndex) => {
        let changeValue = document.getElementById(id + targetIndex).value;
        let newList = [];
        let inputAdultSum = 0;
        let inputChildSum = 0;
        let menSum = 0;
        let womenSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        inputRoomList.forEach((value, index) => {
            let roomObj = value;
            if (index == targetIndex) {
                roomObj[id] = changeValue;
            }
            menSum += Number(roomObj.menCnt);
            womenSum += Number(roomObj.womenCnt)
            childSum += Number(roomObj.childCnt)
            preschoolerSum += Number(roomObj.preschoolerCnt)
            babySum += Number(roomObj.babyCnt)
            newList.push(roomObj);
        })
        inputAdultSum = menSum + womenSum;
        inputChildSum = childSum + preschoolerSum + babySum;
        let adultCnt = inputAdultSum;
        let childCnt = inputChildSum;
        setInputRestaurantFlg(inputAdultSum > 0 && inputAdultSum >= membershipSearchParam.roomCnt)
        setInputRoomList(newList);
        let newInputUserInfo = { ...inputUserInfo };
        newInputUserInfo.adultCnt = inputAdultSum;
        newInputUserInfo.childCnt = childSum;
        newInputUserInfo.preschoolerCnt = preschoolerSum;
        newInputUserInfo.babyCnt = babySum;
        setInputUserInfo(newInputUserInfo);

        // 部屋利用人数を食事情報Stateへ反映
        setMealListPersonCount(mealInfoList, inputAdultSum, childSum, preschoolerSum, babySum);
    }
    
    // 食事情報に利用人数を反映
    const setMealListPersonCount = (mealInfoList, adultSum, childSum, preschoolerSum, babySum) => {
        // 食事情報がなければ早期リターン
        if (!mealInfoList || !mealInfoList.length) return;

        // 素泊まりプランの場合は利用人数を反映しない
        const { breakfastTsukiPlanFlg, dinnerTsukiPlanFlg, thanksFlg } = membershipReserveInfo;
        if (isPlanWithoutMeal(breakfastTsukiPlanFlg, dinnerTsukiPlanFlg, thanksFlg)) return;

        let newMealInfoList = mealInfoList.map((mealInfo) => {
            // コースが選べる場合はスキップ
            if (!isFixedRestaurant(mealInfo)) return mealInfo;

            // レストラン情報がなければスキップ
            if (!mealInfo.planRestaurantList?.length) return mealInfo;
            const planCourseList = mealInfo.planRestaurantList.length === 1
                ? mealInfo.planRestaurantList[0].courseList
                : mealInfo.planRestaurantList.find(x => x.restaurantCd === mealInfo.restaurantCd).courseList;

            // まだコースが1件も設定されていない場合は人数を反映しない
            if (!mealInfo.courseList?.length) return mealInfo;

            // 食事情報の人数を更新
            mealInfo.adultCnt = adultSum;
            mealInfo.childCnt = childSum;
            mealInfo.preschoolerCnt = preschoolerSum;
            mealInfo.babyCnt = babySum;
            mealInfo.riyoNinzu = adultSum + childSum + preschoolerSum + babySum;

            // レストラン・コースが固定のプランの場合はコースの人数を更新
            let newCourseList = [];
            planCourseList && planCourseList.forEach((planCourse) => {
                const newCourse = getCourseInfoPersonCount(planCourse, mealInfo);
                newCourse && newCourseList.push(newCourse);
            })
            mealInfo.courseList = newCourseList;

            return mealInfo;
        })

        setMealInfoList(newMealInfoList);
    }

    // 食事情報からコースごとの設定人数を取得
    const getCourseInfoPersonCount = (planCourseInfo, mealInfo) => {
        const { courseCd, courseName, himozukeAdult, himozukeChild, himozukeYoji } = planCourseInfo;

        const newCourseInfo = { courseCd, courseName };
        // 大人用コース
        if (himozukeAdult === 1 && mealInfo.adultCnt !== 0) {
            return { ...newCourseInfo, courseNum: mealInfo.adultCnt };
        }

        // 小人用コース
        if (himozukeChild === 1 && mealInfo.childCnt !== 0) {
            return { ...newCourseInfo, courseNum: mealInfo.childCnt };
        }

        // 幼児用コース
        const courseNum = mealInfo.preschoolerCnt;
        if (himozukeYoji === 1 && courseNum !== 0) {
            return { ...newCourseInfo, courseNum };
        }

        // どのコースにも紐づかない場合はnullを返す
        return null;
    }

    // 素泊まりプラン判定処理
    const isPlanWithoutMeal = (breakfastTsukiPlanFlg, dinnerTsukiPlanFlg, thanksFlg) => {
        return !breakfastTsukiPlanFlg && !dinnerTsukiPlanFlg && !thanksFlg;
    }

    // レストランが決まっている食事情報か判定
    const isFixedRestaurant = (mealInfo) => {
        if (!mealInfo) return false;

        // すでにレストランが選択されている場合はtrue
        if (!!mealInfo.restaurantCd) return true;

        if (!mealInfo.required) return false;

        // レストラン情報が1件であればtrue
        return mealInfo.planRestaurantList && mealInfo.planRestaurantList.length === 1;
    }

    // 人数合計値設定
    const getPersonCountSum = (roomList) => {
        let newList = [];
        let inputAdultSum = 0;
        let menSum = 0;
        let womenSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        roomList.forEach((value, index) => {
            let roomObj = value;
            menSum += Number(roomObj.menCnt);
            womenSum += Number(roomObj.womenCnt)
            childSum += Number(roomObj.childCnt)
            preschoolerSum += Number(roomObj.preschoolerCnt)
            babySum += Number(roomObj.babyCnt)
            newList.push(roomObj);
        })
        inputAdultSum = menSum + womenSum;
        const ret = {};
        ret.adultCnt = inputAdultSum;
        ret.childCnt = childSum;
        ret.preschoolerCnt = preschoolerSum;
        ret.babyCnt = babySum;
        return ret;
    }

    // 入力内容変更
    const onChangeInputForm = (id) => {
        let changeValue = document.getElementById(id).value;
        let newInputUserInfo = { ...inputUserInfo };
        newInputUserInfo[id] = changeValue;
        setInputUserInfo(newInputUserInfo);
    }

    // 入力内容変更(チェックボックス)
    const onChangeCheckBox = (name) => {
        let changeEle = document.getElementsByName(name);
        let changeValue = changeEle[0].checked;
        let newInputUserInfo = { ...inputUserInfo };
        if (name == "otherMailFlg") {
            let kakuninMailKiboKbnEle = document.getElementsByName("kakuninMailKiboKbn");
            if (kakuninMailKiboKbnEle[0].checked) {
                newInputUserInfo[name] = changeValue;
            }
            if (!changeValue) {
                newInputUserInfo.confirmReserveMail = "";
            }
        } else {
            newInputUserInfo[name] = changeValue;
        }
        if (name == "kakuninMailKiboKbn" && !changeValue) {
            newInputUserInfo.confirmReserveMail = "";
            newInputUserInfo.otherMailFlg = false;
        }
        if (name == "selectRightFlg") { // 権利消化「手動で選ぶ」押下時
            const homeFlForm = document.getElementById("homeFlForm");
            if (homeFlForm) {
                if (changeValue) {
                    homeFlForm.classList.add("hiddenItem");
                    setUsedHomeFlKenriFlg(null);
                    newInputUserInfo.saveHomeFlInfoFlg = false;
                    let saveHomeFlInfoFlgEls = document.getElementsByName("saveHomeFlInfoFlg");
                    if (0 < saveHomeFlInfoFlgEls.length) {
                        saveHomeFlInfoFlgEls.forEach(el => el.checked = false);
                    }
                } else {
                    homeFlForm.classList.remove("hiddenItem");
                }
            }
        }
        if (name == "applicantFlg") {
            newInputUserInfo[name] = changeValue;
            const daihyouNameEl = document.getElementById("daihyouName");
            const daihyouNameKanaEl = document.getElementById("daihyouNameKana");

            if (changeValue) {
                // 代表者名を上書き
                const daihyouName = loginUserInfo.memberSei + " " + loginUserInfo.memberMei;
                if (daihyouNameEl) {
                    newInputUserInfo.daihyouName = daihyouName;
                    daihyouNameEl.value = daihyouName;
                }
                // 代表者名(カナ)を上書き
                const daihyouNameKana = loginUserInfo.memberSeiKana + " " + loginUserInfo.memberMeiKana;
                newInputUserInfo.daihyouNameKana = daihyouNameKana;
                if (daihyouNameKanaEl) {
                    newInputUserInfo.daihyouNameKana = daihyouNameKana;
                    daihyouNameKanaEl.value = daihyouNameKana;
                }
                // 会員様とのご関係を「本人」に上書き
                newInputUserInfo.relationCd = relationList.find(relationInfo => relationInfo.value == "会員本人").id;
            } else {
                // 空文字に上書き
                newInputUserInfo.relationCd = "";
            }

            if (!membershipReserveInfo.generalFlg) {
                requestGetServiceCheck(inputRoomList, newInputUserInfo.relationCd, changeValue);
            }
        }
        setInputUserInfo(newInputUserInfo);
    }

    // 同意チェック変更
    const onChangeAgreement = (mealIndex, doiIndex) => {
        let agreementEle = document.getElementsByName("agreement" + mealIndex + "_" + doiIndex);
        let agreement = agreementEle[0].checked;
        let newMealInfoList = [];
        mealInfoList.forEach(value => {
            let mealInfo = value;
            newMealInfoList.push(mealInfo);
        })
        newMealInfoList[mealIndex].doiList[doiIndex].checked = agreement;
        setMealInfoList(newMealInfoList);
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        // 新規予約の場合
        if (!membershipReserveInfo?.changeFlg) {
            history.push("/reserve/hotel/searchResult");
            return;
        }

        // プラン変更の場合
        if (membershipReserveComf?.pageKbn === "membershipResvComf") {
            history.push("/reserve/hotel/changePlan");
        }
        // 人数変更の場合
        else {
            history.push("/reserve/hotel/hotelBookingConfirmDetail");
        }
    }

    // 予約登録チェック後処理
    const afterSetReserve = (res) => {
        let data = res.data;
        let errorMessage = "";
        let errorFlg = false;
        if (data.resultCode == 0) {
            history.push("/reserve/hotel/confirmUser");
        } else {
            errorMessage = data.errorMessage;
            errorFlg = true;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {
        // 入力チェック
        let errorFlg = false;
        let errorMessageBox = [];
        let flgList = {
            errorRepresentNameKana: false,
            errorRepresentName: false,
            errorRepresentTelKbn: false,
            errorRepresentTelNumber: false,
            errorReserverTelNumber: false,
            errorReserverMail: false,
            errorShattleBusTime: false,
            errorMealList: [],
            errorRoomList: [],
            errorOtherMenuList: [],
            errorFoodRequest: false,
            errorAllergyExistence: false,
            errorAllergyBiko: false,
            errorZipCode: false,
            errorPrefecture: false,
            errorTransport: false,
            errorRelation: false,
            errorAddress1: false,
            errorAddress2: false,
            errorAddress3: false,
            errorSmartCheckIn: false,
            errorNonStopCheckIn: false,
            errorBiko: false,
            errorRight: false,
            errorConfirmReserve: false,
            errorMachiPlanCheckFlg: false,
            validFlg: false,
            requireFlg: false,
            errorUsedHomeFlKenriFlg: false,
            errorApplicantFlg: false,
        };

        let foodRequest = document.getElementById("foodRequest") ? document.getElementById("foodRequest").value : "";
        if (!CommonValidation.Require(foodRequest) && CommonValidation.OverMaxLengthCareHalfHull(foodRequest, 667)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorFoodRequest = true;
        }
        let allergyExistenceList = document.getElementsByName("allergyExistence") ? document.getElementsByName("allergyExistence") : [];
        let allergyExistence = "";
        allergyExistenceList.forEach(value => {
            if (value.checked) {
                allergyExistence = value.value;
            }
        })
        let allergyKbn = allergyExistence;
        let allergyBiko = "";
        if (!membershipReserveInfo.generalFlg && CommonValidation.Require(allergyExistence)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorAllergyExistence = true;
        }
        if (allergyExistence == "1") {
            allergyBiko = document.getElementById("allergyBiko").value;
            if (CommonValidation.Require(allergyBiko)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorAllergyBiko = true;
            }
            if (CommonValidation.OverMaxLengthCareHalfHull(allergyBiko, 667)) {
                flgList.validFlg = true;
                errorFlg = true;
                flgList.errorAllergyBiko = true;
            }
        }
        let daihyouName = document.getElementById("daihyouName").value;
        let daihyouNameKana = document.getElementById("daihyouNameKana").value;
        let mainPhoneKbnList = document.getElementsByName("mainPhoneKbn");
        let mainPhoneKbn = "";
        mainPhoneKbnList.forEach(value => {
            if (value.checked) {
                mainPhoneKbn = value.value;
            }
        })
        let mainPhoneNumber = document.getElementById("mainPhoneNumber").value;
        let contactPhoneNumber = document.getElementById("contactPhoneNumber") ? document.getElementById("contactPhoneNumber").value : "";
        let contactMailAddress = document.getElementById("contactMailAddress") ? document.getElementById("contactMailAddress").value : "";
        let relation = document.getElementById("relation") ? document.getElementById("relation").value : "";
        let zipCode1 = document.getElementById("zipCode1") ? document.getElementById("zipCode1").value : "";
        let zipCode2 = document.getElementById("zipCode2") ? document.getElementById("zipCode2").value : "";
        let prefecture = document.getElementById("prefectureCd") ? document.getElementById("prefectureCd").value : "";
        let address1 = document.getElementById("address1") ? document.getElementById("address1").value : "";
        let address2 = document.getElementById("address2") ? document.getElementById("address2").value : "";
        let address3 = document.getElementById("address3") ? document.getElementById("address3").value : "";
        let transport = document.getElementById("transport") ? document.getElementById("transport").value : "";
        let carCntEle = document.getElementById("carCnt");
        let carCnt = carCntEle ? Number(carCntEle.value) : 0;
        let busTime = inputUserInfo.busTime ? inputUserInfo.busTime : "";
        let kozafurikaeFlgEle = document.getElementsByName("kozafurikaeFlg");
        let kozafurikaeFlg = kozafurikaeFlgEle.length != 0 ? kozafurikaeFlgEle[0].checked : false;
        let smartCheckInFlgEle = document.getElementsByName("smartCheckInFlg");
        let smartCheckInFlg = smartCheckInFlgEle.length != 0 ? smartCheckInFlgEle[0].checked : false;
        let smartCheckOutFlgEle = document.getElementsByName("smartCheckOutFlg");
        let smartCheckOutFlg = smartCheckOutFlgEle.length != 0 ? smartCheckOutFlgEle[0].checked : false;
        let nonstopCheckInFlgEle = document.getElementsByName("nonstopCheckInFlg");
        let nonstopCheckInFlg = nonstopCheckInFlgEle.length != 0 ? nonstopCheckInFlgEle[0].checked : false;
        let biko = document.getElementById("biko").value;
        let selectRightFlgEle = document.getElementsByName("selectRightFlg");
        let selectRightFlg = selectRightFlgEle.length != 0 ? selectRightFlgEle[0].checked : "";
        let saveHomeFlInfoFlgEle = document.getElementsByName("saveHomeFlInfoFlg");
        let saveHomeFlInfoFlg = saveHomeFlInfoFlgEle.length != 0 ? saveHomeFlInfoFlgEle[0].checked : "";
        let kakuninMailKiboKbnEle = document.getElementsByName("kakuninMailKiboKbn");
        let kakuninMailKiboKbn = kakuninMailKiboKbnEle.length != 0 ? kakuninMailKiboKbnEle[0].checked : "";
        let otherMailFlgEle = document.getElementsByName("otherMailFlg");
        let otherMailFlg = otherMailFlgEle.length != 0 ? otherMailFlgEle[0].checked : "";
        let confirmReserveMail = document.getElementById("confirmReserveMail") ? document.getElementById("confirmReserveMail").value : "";
        let machiPlanCheckFlgEle = document.getElementsByName("machiPlanCheckFlg");
        let machiPlanCheckFlg = machiPlanCheckFlgEle.length != 0 ? machiPlanCheckFlgEle[0].checked : "";
        let applicantFlgEls = document.getElementsByName("applicantFlg");
        let applicantFlg = null;
        applicantFlgEls.forEach(value => {
            if (value.checked) {
                applicantFlg = JSON.parse(value.value.toLowerCase());
            }
        });

        let reqInputRoomList = [];
        let roomTypeCdList = [];
        let adultSum = 0;
        let totalChildSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        let machiPlanKenriFlg = false;
        let zanDateList  = [];
        inputRoomList.forEach((value, index) => {
            let errorRoom = {
                errorRoomType: false,
                errorAdultNum: false,
                errorChildNum: false,
            }
            let roomType = membershipReserveInfo.generalFlg ? membershipReserveInfo.planCd : value.roomType;
            roomTypeCdList.push(roomType);
            // let roomCapacity = roomTypeList.find(value => value.id == roomType) ? roomTypeList.find(value => value.id == roomType).roomCapacity : 0;
            let menCnt = Number(document.getElementById("menCnt" + index).value);
            let womenCnt = Number(document.getElementById("womenCnt" + index).value);
            let childCnt = Number(document.getElementById("childCnt" + index).value);
            let preschoolerCnt = Number(document.getElementById("preschoolerCnt" + index).value);
            let babyCnt = Number(document.getElementById("babyCnt" + index).value);
            // let roomCheckNum = menCnt + womenCnt + childCnt;
            if (!membershipReserveInfo.generalFlg && CommonValidation.Require(roomType)) {
                flgList.requireFlg = true;
                errorFlg = true;
                errorRoom.errorRoomType = true;
            }
            if ((menCnt + womenCnt) == 0) {
                flgList.validFlg = true;
                errorFlg = true;
                errorRoom.errorAdultNum = true;
            }
            // ROOM_CAPACITY_ERRORの設定
            // let roomCapacityErrorFlg = roomCheckNum == 0;
            // if (!roomCapacityErrorFlg) {
            //     roomCapacityErrorFlg = membershipReserveInfo.generalFlg ? roomCheckNum > Const.MAX_ROOM_CAPACITY : roomCheckNum > roomCapacity;
            // }
            // if (roomCapacityErrorFlg) {
            //     flgList.validFlg = true;
            //     errorFlg = true;
            //     errorRoom.errorAdultNum = true;
            //     errorRoom.errorChildNum = true;
            //     errorMessageBox.push(MessageConst.ROOM_CAPACITY_ERROR);
            // }
            adultSum += (menCnt + womenCnt);
            totalChildSum += (childCnt + preschoolerCnt + babyCnt);
            childSum += childCnt;
            preschoolerSum += preschoolerCnt;
            babySum += babyCnt;
            flgList.errorRoomList.push(errorRoom);
            reqInputRoomList.push({
                humanCount: menCnt + womenCnt + childCnt + preschoolerCnt + babyCnt,
                roomCount: index,
                roomType: roomType,
                roomTypeName: value.roomTypeName,
                menCnt: menCnt,
                womenCnt: womenCnt,
                adultCnt: menCnt + womenCnt,
                childCnt: childCnt,
                preschoolerCnt: preschoolerCnt,
                babyCnt: babyCnt,
                machiLabel: value.machiLabel
            })
            if (membershipReserveInfo.machiFlg === "2" && value.machiLabel === "※一部空きあり") {
                let zanDate = [];
                value.roomDayList.forEach(date => {
                    if (date.zanRoom > 0) {
                        zanDate.push(date.day);
                    }
                })
                zanDateList.push(zanDate);
                machiPlanKenriFlg = true;
            }
        });
        if (machiPlanKenriFlg) {
            if (zanDateList.length != inputRoomList.length) {
                // エラーポップアップ
                setPopupData({
                    message: MessageConst.MACHI_KENRI_ERROR,
                });
                onClickOpenPopupWindow("error");
                errorFlg = true;
            } else {
                let baseList = [];
                zanDateList.forEach(value => {
                    if (baseList.length < value.length) {
                        baseList = value;
                    }
                })
                let zanDateError = false;
                baseList.forEach(date => {
                    if (zanDateList.some(value => !value.includes(date))) {
                        zanDateError = true;
                    }
                });
                if (zanDateError) {
                    // エラーポップアップ
                    setPopupData({
                        message: MessageConst.MACHI_KENRI_ERROR,
                    });
                    onClickOpenPopupWindow("error");
                    errorFlg = true;
                } else if(membershipReserveInfo.machiFlg === "2" && membershipSearchParam.riyoKaiinkenSyubetCd !== 3) {
                    selectRightFlg = true
                }
            }
        }
        let inputAcconpanyFlg = !membershipReserveInfo.generalFlg && (adultSum + totalChildSum) > 1;
        let inputFoodList = [];
        let inputFoodCourseList = [];
        if (!membershipReserveInfo.generalFlg && membershipReserveInfo.machiFlg == 0) {
            mealInfoList.forEach((value, index) => {
                let errorMeal = {
                    errorRestaurantCd: false,
                    errorRiyoNinzu: false,
                    errorMealTime: false,
                    errorCourse: false,
                    errorDoi: [],
                }
                let restaurantCd = value.restaurantCd
                const required = value.required;
                let riyoNinzu = value.riyoNinzu;
                let adultCnt = value.adultCnt;
                let childCnt = value.childCnt;
                let preschoolerCnt = value.preschoolerCnt;
                let babyCnt = value.babyCnt;
                let mealTime = value.mealTime
                let jikantaiKbn = value.jikantaiKbn
                let courseList = value.courseList
                let doiList = value.doiList
                let sykjYykDataId = value.sykjYykDataId;

                if (CommonValidation.Require(restaurantCd)) {
                    flgList.requireFlg = true;
                    errorFlg = true;
                    errorMeal.errorRestaurantCd = true;
                } else if (restaurantCd != "89" && restaurantCd != "88" && restaurantCd != "V0") {
                    if (required ? adultCnt != adultSum : adultCnt > adultSum) {
                        flgList.validFlg = true;
                        errorFlg = true;
                        errorMeal.errorRestaurantCd = true;
                        errorMeal.errorRiyoNinzu = true;
                        errorMeal.errorMealTime = true;
                        errorMeal.errorCourse = true;
                    }
                    if (required ? childCnt != childSum : childCnt > childSum) {
                        flgList.validFlg = true;
                        errorFlg = true;
                        errorMeal.errorRestaurantCd = true;
                        errorMeal.errorRiyoNinzu = true;
                        errorMeal.errorMealTime = true;
                        errorMeal.errorCourse = true;
                    }
                    if (required ? preschoolerCnt != preschoolerSum : preschoolerCnt > preschoolerSum) {
                        flgList.validFlg = true;
                        errorFlg = true;
                        errorMeal.errorRestaurantCd = true;
                        errorMeal.errorRiyoNinzu = true;
                        errorMeal.errorMealTime = true;
                        errorMeal.errorCourse = true;
                    }
                    if (!required && babyCnt > babySum) {
                        flgList.validFlg = true;
                        errorFlg = true;
                        errorMeal.errorRestaurantCd = true;
                        errorMeal.errorRiyoNinzu = true;
                        errorMeal.errorMealTime = true;
                        errorMeal.errorCourse = true;
                    }
                    if (CommonValidation.Require(mealTime)) {
                        flgList.requireFlg = true;
                        errorFlg = true;
                        errorMeal.errorMealTime = true;
                    }
                    doiList.forEach(doiInfo => {
                        if (doiInfo.checked) {
                            errorMeal.errorDoi.push(false);
                        } else {
                            flgList.requireFlg = true;
                            errorFlg = true;
                            errorMeal.errorDoi.push(true);
                        }
                    })
                    if (!courseList || courseList.length == 0) {
                        flgList.validFlg = true;
                        errorFlg = true;
                        errorMeal.errorCourse = true;
                    } else {
                        let humanSum = 0;
                        courseList.forEach(course => {
                            humanSum += course.courseNum ? Number(course.courseNum) : 0;
                            inputFoodCourseList.push({
                                riyoDate: value.restaurantRiyoDate,
                                jikantaiKbn: jikantaiKbn,
                                restaurantCd: restaurantCd,
                                foodCourseCd: course.courseCd,
                                targetCnt: course.courseNum,
                                sykjYykDataId: sykjYykDataId
                            })
                        })
                        if (required && value.planRestaurantList?.length &&
                            (babyCnt > 0 ? (adultSum + totalChildSum < humanSum || (adultSum + totalChildSum - babyCnt) > humanSum) :
                                value.riyoNinzu != humanSum)) {
                            // 食事付きプランの場合
                            flgList.validFlg = true;
                            errorFlg = true;
                            errorMeal.errorCourse = true;
                        } else if (required && !value.planRestaurantList?.length &&
                            ((babyCnt > 0 || preschoolerCnt > 0) ? (adultSum + totalChildSum < humanSum || (adultSum + totalChildSum - babyCnt - preschoolerCnt) > humanSum) :
                                value.riyoNinzu != humanSum)) {
                            // ディナーチョイスの場合
                            flgList.validFlg = true;
                            errorFlg = true;
                            errorMeal.errorCourse = true;
                        } else if (!required && (value.riyoNinzu < humanSum || (value.riyoNinzu - babyCnt - preschoolerCnt) > humanSum)) {
                            // 素泊まりプランの場合
                            flgList.validFlg = true;
                            errorFlg = true;
                            errorMeal.errorCourse = true;
                        }
                    }
                    inputFoodList.push({
                        riyoDate: value.restaurantRiyoDate,
                        jikantaiKbn: jikantaiKbn,
                        restaurantCd: restaurantCd,
                        startTime: mealTime,
                        adultCnt: adultCnt,
                        childCnt: childCnt,
                        preschoolerCnt: preschoolerCnt,
                        babyCnt: babyCnt,
                        sykjYykDataId: sykjYykDataId
                    });
                } else if (restaurantCd == "88" || restaurantCd == "89") {
                    // 朝食不要/夕食不要の場合は部屋人数をそのままレストランの人数にセット
                    inputFoodList.push({
                        riyoDate: value.restaurantRiyoDate,
                        jikantaiKbn: jikantaiKbn,
                        restaurantCd: restaurantCd,
                        adultCnt: adultSum,
                        childCnt: childSum,
                        preschoolerCnt: preschoolerSum,
                        babyCnt: babySum
                    });
                }
                flgList.errorMealList.push(errorMeal);
            });
        }
        // バリデーションチェック
        if (!CommonValidation.Require(daihyouName) && (CommonValidation.ZenkakuAndSpace(daihyouName) || CommonValidation.OverMaxLength(daihyouName, 36))) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorRepresentName = true;
        }
        if (CommonValidation.Require(daihyouNameKana)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorRepresentNameKana = true;
        }
        if (CommonValidation.NameKanaSLC(daihyouNameKana) || CommonValidation.OverMaxLength(daihyouNameKana, 36)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorRepresentNameKana = true;
        }
        if (!membershipReserveInfo.generalFlg && CommonValidation.Require(mainPhoneKbn)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorRepresentTelKbn = true;
        }
        if (CommonValidation.Require(mainPhoneNumber)){
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorRepresentTelNumber = true;
        }
        if (CommonValidation.OverMaxLength(mainPhoneNumber, 16)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorRepresentTelNumber = true;
        }
        if (!membershipReserveInfo.generalFlg && CommonValidation.Require(contactPhoneNumber)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorReserverTelNumber = true;
        }
        if (!membershipReserveInfo.generalFlg && CommonValidation.OverMaxLength(contactPhoneNumber, 16)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorReserverTelNumber = true;
        }
        if (!membershipReserveInfo.generalFlg && CommonValidation.Require(relation)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorRelation = true;
        }
        if (CommonValidation.Require(prefecture)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorPrefecture = true;
        }
        if (CommonValidation.Require(transport)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorTransport = true;
        }
        const prefectureName = prefectureList.find(value => value.id == prefecture) ? prefectureList.find(value => value.id === prefecture).value : '';
        if (membershipReserveInfo.generalFlg) {
            if (CommonValidation.Require(zipCode1)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorZipCode = true;
            } else if (zipCode1.length !== 3 || CommonValidation.HankakuNum(zipCode1)) {
                flgList.validFlg = true;
                errorFlg = true;
                flgList.errorZipCode = true;
            }
            if (CommonValidation.Require(zipCode2)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorZipCode = true;
            } else if (zipCode2.length !== 4 || CommonValidation.HankakuNum(zipCode2)) {
                flgList.validFlg = true;
                errorFlg = true;
                flgList.errorZipCode = true;
            }
            if (CommonValidation.Require(address1)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorAddress1 = true;
            }
            if (CommonValidation.Require(address2)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorAddress2 = true;
            }
            if (CommonValidation.Require(address3)) {
                flgList.requireFlg = true;
                errorFlg = true;
                flgList.errorAddress3 = true;
            }
            if (CommonValidation.OverMaxLength(`${prefectureName}${address1}${address2}${address3}`, 253)) {
                flgList.validFlg = true;
                errorFlg = true;
                flgList.errorPrefecture = true;
                flgList.errorAddress1 = true;
                flgList.errorAddress2 = true;
                flgList.errorAddress3 = true;
            }
        }
        if (CommonValidation.Require(contactMailAddress)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorReserverMail = true;
        } else if (CommonValidation.NotMail(contactMailAddress) || CommonValidation.OverMaxLength(contactMailAddress, 51)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorReserverMail = true;
        }
        if (!CommonValidation.Require(biko) && CommonValidation.OverMaxLengthCareHalfHull(biko, 667)) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorBiko = true;
        }
        if (transport == transportList.find(value => value.value == "車").id && CommonValidation.Require(carCnt)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorCarNum = true;
        }
        if (smartCheckInFlg && nonstopCheckInFlg) {
            flgList.validFlg = true;
            errorFlg = true;
            flgList.errorSmartCheckIn = true;
            flgList.errorNonStopCheckIn = true;
        }
        // if (selectRightFlgEle.length !== 0 && right.length === 0) {
        //     flgList.validFlg = true;
        //     errorFlg = true;
        //     flgList.errorRight = true;
        //     errorMessageBox.push("権利が不足しているためお申込みいただくことができません。/n泊数か室数を減らして、再度お申込みください。");
        // }
        if (kakuninMailKiboKbn) {
            if (membershipReserveInfo.changeFlg || otherMailFlg) {
                if (CommonValidation.Require(confirmReserveMail)) {
                    flgList.requireFlg = true;
                    errorFlg = true;
                    flgList.errorConfirmReserve = true;
                } else if (CommonValidation.NotMail(confirmReserveMail) || CommonValidation.OverMaxLength(confirmReserveMail, 51)) {
                    flgList.validFlg = true;
                    errorFlg = true;
                    flgList.errorConfirmReserve = true;
                }
            } else {
                confirmReserveMail = contactMailAddress;
            }
        }
        if (machiPlanCheckFlgEle.length && !machiPlanCheckFlg) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorMachiPlanCheckFlg = true;
        }
        if (!isCrawl && !membershipReserveInfo.generalFlg && applicantFlg === null) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorApplicantFlg = true;
        }
        if (!membershipReserveInfo.generalFlg && !membershipReserveInfo.thanksFlg && membershipReserveInfo.machiFlg != "2" &&
            !(membershipReserveComf.shokaKenriList != null && membershipReserveComf.shokaKenriList.length > 0) &&
            serviceCheckInfo &&
            serviceCheckInfo.kenrishokaYoFlg == "1" &&
            serviceCheckInfo.homeFlKanoFlg == "1" &&
            !selectRightFlg &&
            CommonValidation.Require(usedHomeFlKenriFlg)) {
            flgList.requireFlg = true;
            errorFlg = true;
            flgList.errorUsedHomeFlKenriFlg = true;
        }
        if (errorFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            if (flgList.requireFlg) {
                errorMessageBox.push(MessageConst.REQUIRE_INPUT_ERROR);
            }
            if (flgList.validFlg) {
                errorMessageBox.push(MessageConst.VALID_INPUT_ERROR);
            }
        } else {
            const newInputUserInfo = {
                ...inputUserInfo,
                roomList: reqInputRoomList,
                foodList: inputFoodList,
                foodCourseList: inputFoodCourseList,
                foodRequest: foodRequest,
                allergyKbn: allergyKbn,
                allergyBiko: allergyBiko,
                applicantNameKana: applicantNameKana,
                applicantName: applicantName,
                daihyouNameKana: daihyouNameKana,
                daihyouName: daihyouName,
                mainPhoneKbn: mainPhoneKbn,
                mainPhoneNumber: mainPhoneNumber,
                contactPhoneNumber: contactPhoneNumber,
                contactMailAddress: contactMailAddress,
                relation: relationList.find(value => value.id == relation).value,
                relationCd: relation,
                prefecture: prefectureList.find(value => value.id == prefecture).value,
                prefectureCd: prefecture,
                zipCode1: zipCode1,
                zipCode2: zipCode2,
                address1: address1,
                address2: address2,
                address3: address3,
                transport: transportList.find(value => value.id == transport).value,
                transportCd: transport,
                carCnt: carCnt,
                busTime: busTime,
                kozafurikaeDispFlg: kozafurikaeFlgEle.length != 0,
                kozafurikaeFlg: kozafurikaeFlg,
                smartCheckInDispFlg: smartCheckInFlgEle.length != 0,
                smartCheckInFlg: smartCheckInFlg,
                smartCheckOutDispFlg: smartCheckOutFlgEle.length != 0,
                smartCheckOutFlg: smartCheckOutFlg,
                nonstopCheckInDispFlg: nonstopCheckInFlgEle.length != 0,
                nonstopCheckInFlg: nonstopCheckInFlg,
                biko: biko,
                kakuninMailKiboKbn: kakuninMailKiboKbn,
                confirmReserveMail: confirmReserveMail,
                machiFlg: membershipReserveInfo.machiFlg,
                machiPlanCheckDispFlg: machiPlanCheckFlgEle.length != 0,
                selectRightFlg: selectRightFlg,
                usedHomeFlKenriFlg: usedHomeFlKenriFlg,
                saveHomeFlInfoFlg: saveHomeFlInfoFlg,
                inputAcconpanyFlg: inputAcconpanyFlg,
                inputRoomList: inputRoomList,
                inputMealInfoList: mealInfoList,
                applicantFlg: applicantFlg
            }
            setInputUserInfo(newInputUserInfo)
            setServiceCheckInfo({ ...serviceCheckInfo })
            // 権利消化要の場合
            if (!membershipReserveInfo.generalFlg && (membershipReserveInfo.machiFlg != "2" || machiPlanKenriFlg) && serviceCheckInfo && serviceCheckInfo.kenrishokaYoFlg == "1" && !membershipReserveInfo.thanksFlg) {
                // 新規の場合権利消化割当する
                if (!membershipReserveInfo.changeFlg) {
                    if (machiPlanKenriFlg || selectRightFlg) {
                        setRight([]);
                        history.push("/reserve/hotel/chooseRight");
                    } else {
                        requestGetKenriWariate(roomTypeCdList, newInputUserInfo);
                    }
                }
                // 変更の場合
                else {
                    // 権利消化不要から権利消化要に変更された場合、権利消化割当する
                    const isPrevKenrishokaYo = membershipReserveComf.shokaKenriList != null && membershipReserveComf.shokaKenriList.length > 0;
                    if (!isPrevKenrishokaYo && membershipReserveComf.thanksFlg) {
                        requestGetKenriWariate(roomTypeCdList, newInputUserInfo);
                    }
                    // それ以外は空をセット
                    else {
                        setRight([]);
                        const req = {
                            shisetsuCd: membershipReserveInfo.shisetsuCd,
                            yoyakuNo: membershipReserveInfo.yoyakuNo,
                            keiyakuNo: membershipSearchParam.keiyakuNo,
                            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                            pointKaiinId: membershipSearchParam.memberCd,
                            riyoDate: membershipSearchParam.checkInDate,
                            hakuCnt: membershipSearchParam.nights,
                            planCd: membershipReserveInfo.planCd,
                            planShohinCd: membershipReserveInfo.planShohinCd,
                            foodRequest: newInputUserInfo.foodRequest,
                            allergyKbn: newInputUserInfo.allergyKbn,
                            allergyBiko: newInputUserInfo.allergyBiko,
                            applicantNameKana: newInputUserInfo.applicantNameKana,
                            applicantName: newInputUserInfo.applicantName,
                            daihyouNameKana: newInputUserInfo.daihyouNameKana,
                            daihyouName: newInputUserInfo.daihyouName,
                            mainPhoneKbn: newInputUserInfo.mainPhoneKbn,
                            mainPhoneNumber: newInputUserInfo.mainPhoneNumber,
                            contactPhoneNumber: newInputUserInfo.contactPhoneNumber,
                            contactMailAddress: newInputUserInfo.contactMailAddress,
                            relationCd: newInputUserInfo.relationCd,
                            prefectureCd: newInputUserInfo.prefectureCd,
                            prefecture: newInputUserInfo.prefecture,
                            zipCode1: newInputUserInfo.zipCode1,
                            zipCode2: newInputUserInfo.zipCode2,
                            address1: newInputUserInfo.address1,
                            address2: newInputUserInfo.address2,
                            address3: newInputUserInfo.address3,
                            transportCd: newInputUserInfo.transportCd,
                            carCnt: newInputUserInfo.carCnt,
                            busTime: newInputUserInfo.busTime,
                            kozafurikaeFlg: newInputUserInfo.kozafurikaeFlg,
                            smartCheckInFlg: newInputUserInfo.smartCheckInFlg,
                            smartCheckOutFlg: newInputUserInfo.smartCheckOutFlg,
                            nonstopCheckInFlg: newInputUserInfo.nonstopCheckInFlg,
                            biko: newInputUserInfo.biko,
                            kakuninMailKiboKbn: newInputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                            kakuninMailAddress: newInputUserInfo.confirmReserveMail,
                            machiFlg: newInputUserInfo.machiFlg,
                            roomList: newInputUserInfo.roomList,
                            foodList: newInputUserInfo.foodList,
                            foodCourseList: newInputUserInfo.foodCourseList,
                            shokaKenriList: [],
                            dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                            breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                            thanksFlg: membershipReserveInfo.thanksFlg,
                            registFlg: false,
                            applicantFlg: newInputUserInfo.applicantFlg,
                            userInfo,
                        }

                        common.doPost(changeReserve, req, afterSetReserve);
                    }
                }
            } else {
                setRight([]);
                let req = {}
                if (membershipReserveInfo.changeFlg) {
                    // リクエスト設定
                    req = {
                        shisetsuCd: membershipReserveInfo.shisetsuCd,
                        yoyakuNo: membershipReserveInfo.yoyakuNo,
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                        pointKaiinId: membershipSearchParam.memberCd,
                        riyoDate: membershipSearchParam.checkInDate,
                        hakuCnt: membershipSearchParam.nights,
                        planCd: membershipReserveInfo.planCd,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                        foodRequest: newInputUserInfo.foodRequest,
                        allergyKbn: newInputUserInfo.allergyKbn,
                        allergyBiko: newInputUserInfo.allergyBiko,
                        applicantNameKana: newInputUserInfo.applicantNameKana,
                        applicantName: newInputUserInfo.applicantName,
                        daihyouNameKana: newInputUserInfo.daihyouNameKana,
                        daihyouName: newInputUserInfo.daihyouName,
                        mainPhoneKbn: newInputUserInfo.mainPhoneKbn,
                        mainPhoneNumber: newInputUserInfo.mainPhoneNumber,
                        contactPhoneNumber: newInputUserInfo.contactPhoneNumber,
                        contactMailAddress: newInputUserInfo.contactMailAddress,
                        relationCd: newInputUserInfo.relationCd,
                        prefectureCd: newInputUserInfo.prefectureCd,
                        prefecture: newInputUserInfo.prefecture,
                        zipCode1: newInputUserInfo.zipCode1,
                        zipCode2: newInputUserInfo.zipCode2,
                        address1: newInputUserInfo.address1,
                        address2: newInputUserInfo.address2,
                        address3: newInputUserInfo.address3,
                        transportCd: newInputUserInfo.transportCd,
                        carCnt: newInputUserInfo.carCnt,
                        busTime: newInputUserInfo.busTime,
                        kozafurikaeFlg: newInputUserInfo.kozafurikaeFlg,
                        smartCheckInFlg: newInputUserInfo.smartCheckInFlg,
                        smartCheckOutFlg: newInputUserInfo.smartCheckOutFlg,
                        nonstopCheckInFlg: newInputUserInfo.nonstopCheckInFlg,
                        biko: newInputUserInfo.biko,
                        kakuninMailKiboKbn: newInputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                        kakuninMailAddress: newInputUserInfo.confirmReserveMail,
                        machiFlg: newInputUserInfo.machiFlg,
                        roomList: newInputUserInfo.roomList,
                        foodList: newInputUserInfo.foodList,
                        foodCourseList: newInputUserInfo.foodCourseList,
                        shokaKenriList: [],
                        dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                        breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                        thanksFlg: membershipReserveInfo.thanksFlg,
                        registFlg: false,
                        applicantFlg: newInputUserInfo.applicantFlg,
                        userInfo,
                    }

                    common.doPost(changeReserve, req, afterSetReserve);
                } else {
                    // const mealFlg = membershipReserveInfo.planCd &&
                    //     (membershipReserveInfo.breakfastTsukiPlanFlg || membershipReserveInfo.dinnerTsukiPlanFlg || membershipReserveInfo.thanksFlg ||
                    //     membershipReserveInfo?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE);
                    // リクエスト設定
                    req = {
                        shisetsuCd: membershipReserveInfo.shisetsuCd,
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                        pointKaiinId: membershipSearchParam.memberCd,
                        riyoDate: membershipSearchParam.checkInDate,
                        hakuCnt: membershipSearchParam.nights,
                        planCd: membershipReserveInfo.planCd,
                        // planCd: mealFlg ? membershipReserveInfo.planCd : null,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        planCategoryDetailCd: membershipReserveInfo.planCategoryDetailCd,
                        foodRequest: newInputUserInfo.foodRequest,
                        allergyKbn: newInputUserInfo.allergyKbn,
                        allergyBiko: newInputUserInfo.allergyBiko,
                        applicantNameKana: newInputUserInfo.applicantNameKana,
                        applicantName: newInputUserInfo.applicantName,
                        daihyouNameKana: newInputUserInfo.daihyouNameKana,
                        daihyouName: newInputUserInfo.daihyouName,
                        mainPhoneKbn: newInputUserInfo.mainPhoneKbn,
                        mainPhoneNumber: newInputUserInfo.mainPhoneNumber,
                        contactPhoneNumber: newInputUserInfo.contactPhoneNumber,
                        contactMailAddress: newInputUserInfo.contactMailAddress,
                        relationCd: newInputUserInfo.relationCd,
                        prefectureCd: newInputUserInfo.prefectureCd,
                        prefecture: newInputUserInfo.prefecture,
                        zipCode1: newInputUserInfo.zipCode1,
                        zipCode2: newInputUserInfo.zipCode2,
                        address1: newInputUserInfo.address1,
                        address2: newInputUserInfo.address2,
                        address3: newInputUserInfo.address3,
                        transportCd: newInputUserInfo.transportCd,
                        carCnt: newInputUserInfo.carCnt,
                        busTime: newInputUserInfo.busTime,
                        kozafurikaeFlg: newInputUserInfo.kozafurikaeFlg,
                        smartCheckInFlg: newInputUserInfo.smartCheckInFlg,
                        smartCheckOutFlg: newInputUserInfo.smartCheckOutFlg,
                        nonstopCheckInFlg: newInputUserInfo.nonstopCheckInFlg,
                        biko: newInputUserInfo.biko,
                        kakuninMailKiboKbn: newInputUserInfo.kakuninMailKiboKbn ? "1" : "0",
                        kakuninMailAddress: newInputUserInfo.confirmReserveMail,
                        machiFlg: newInputUserInfo.machiFlg,
                        roomList: newInputUserInfo.roomList,
                        foodList: newInputUserInfo.foodList,
                        foodCourseList: newInputUserInfo.foodCourseList,
                        shokaKenriList: [],
                        importedFlg: membershipReserveInfo.generalFlg,
                        dinnerTsukiFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                        breakfastTsukiFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                        thanksFlg: membershipReserveInfo.thanksFlg,
                        registFlg: false,
                        applicantFlg: newInputUserInfo.applicantFlg,
                        userInfo,
                    }

                    common.doPost(setReserve, req, afterSetReserve);
                }
            }
        }
        setErrorInfo({ errorMessageBox: errorMessageBox, errorFlg: errorFlg });
        setFlgList(flgList);
    }

    /**
     * 会員リストの家族会員フラグを設定します。
     * @param {string|null} keiyakuNo 
     */
    const setFamilyFlgInkaiinInfoList = (keiyakuNo) => {
        login.memberInfo?.forEach(member => {
            member.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
                if (kaiinInfo.keiyakuNo == keiyakuNo) {
                    setFamilyFlg(kaiinInfo.familyFlg);
                    return;
                }
            })
        });
    };

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel={state.categoryLabel}
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            {illegalFlg ?
                <div className="reserveInputWrapper">
                    <Label
                        label={MessageConst.ILLEGAL_ACCESS_ERROR}
                        style={styles.errorDiv}
                    />
                </div>
                :
                <>
                    <div className="reserveInputWrapper">
                        <div className={"reserveInfo"} style={styles.userInput}>
                            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                                <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessageBox} />
                            </div>
                            <Label
                                label={"ご予約内容"}
                                className="titleLabel"
                            />
                            <div className={"reserveInfoContentBlock lastContent"}>
                                <div className={"reserveInfoContentBlock "}>
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label="ホテル名"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipReserveInfo.shisetsuName}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock ">
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label="チェックイン"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={commonUtil.getStringFromDateJpnMembership(membershipSearchParam.checkInDate)}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label="チェックアウト"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={commonUtil.getStringFromDateJpnMembership(membershipSearchParam.checkOutDate)}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label=""
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.nights + "泊"}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label="室数"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.roomCnt + "室"}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock ">
                                    <div className="reservationContent lastContent">
                                        <Label
                                            label="宿泊プラン名"
                                            className="reserveInfoTitleGray"
                                        />
                                        <div className="reserveInfoContentLabel">
                                            <div>
                                                <Label
                                                    label={membershipReserveInfo.machiFlg === "1" ? "交換待ち" : membershipReserveInfo.machiFlg === "2" ? "キャンセル待ち" : membershipReserveInfo.planName}
                                                />
                                                <div>
                                                    {membershipReserveInfo.dinnerRyokinAdult ? "夕食" + membershipReserveInfo.dinnerRyokinAdult.toLocaleString() + "円" : ""}
                                                    {membershipReserveInfo.dinnerRyokinAdult && membershipReserveInfo.breakfastTsukiPlanFlg ? "・" : ""}
                                                    {membershipReserveInfo.breakfastTsukiPlanFlg ? "朝食付き" : ""}
                                                </div>
                                            </div>
                                            <img
                                                src={thanks_logo}
                                                style={membershipReserveInfo.thanksFlg ? { height: "40px" } : { display: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock lastContent">
                                    <div className="reservationContent">
                                        <Label
                                            label="会員番号"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={membershipSearchParam.kaiinkenNo}
                                            className="reserveInfoContentLabel"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 部屋情報入力フォーム */}
                    <RoomInputList
                        roomList={inputRoomList}
                        roomTypeList={roomTypeList}
                        adultNumList={adultNumList}
                        childNumList={childNumList}
                        id={props.id}
                        titleClassName="titleLabel"
                        flgList={flgList}
                        responsiveFlg={isWideTablet}
                        generalFlg={membershipReserveInfo.generalFlg}
                        onClickOpenRoomPopup={onClickOpenRoomPopup}
                        onChangeHumanNum={onChangeHumanNum}
                        roomTypeDisabled={membershipReserveInfo.changeFlg && (membershipReserveInfo.machiFlg !== "0" || membershipReserveInfo.assignFlg == 1)}
                    />
                    {/* 食事情報入力フォーム */}
                    <MealInputList
                        mealList={mealInfoList ? mealInfoList : []}
                        roomList={inputRoomList}
                        otherMenuList={otherMenuInfoList ? otherMenuInfoList : []}
                        inputUserInfo={inputUserInfo ? inputUserInfo : {}}
                        reserveInfo={membershipReserveInfo ? membershipReserveInfo : []}
                        prefectureList={prefectureList}
                        relationList={relationList}
                        transportList={transportList}
                        jikantaiKbnList={jikantaiKbnList}
                        serviceCheckInfo={serviceCheckInfo}
                        titleClassName="titleLabel"
                        flgList={flgList}
                        inputRestaurantFlg={inputRestaurantFlg}
                        responsiveFlg={isWideTablet}
                        machiFlg={membershipReserveInfo.machiFlg}
                        generalFlg={membershipReserveInfo.generalFlg}
                        thanksFlg={membershipReserveInfo.thanksFlg}
                        shokaKenriList={membershipReserveComf.shokaKenriList}
                        onClickRestaurant={onClickRestaurant}
                        onClickDoiTitle={onClickDoiTitle}
                        onClickRiyoNinzu={onClickRiyoNinzu}
                        onClickMealTime={onClickMealTime}
                        onClickCourse={onClickCourse}
                        onClickShuttleBusTime={onClickShuttleBusTime}
                        onClickSearchAddress={onClickSearchAddress}
                        onClickServiceLink={onClickServiceLink}
                        onChangeRelation={onChangeRelation}
                        onChangeTransport={onChangeTransport}
                        onChangeAllergyInfo={onChangeAllergyInfo}
                        onChangeInputForm={onChangeInputForm}
                        onChangeCheckBox={onChangeCheckBox}
                        onChangeAgreement={onChangeAgreement}
                        onClickOpenPopupWindow={onClickOpenPopupWindow}
                        machiMongon={inputUserInfo.machiMongon}
                        onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                        usedHomeFlKenriFlg={usedHomeFlKenriFlg}
                        onChangeUsedHomeFlKenriFlg={onChangeUsedHomeFlKenriFlg}
                        onChangeApplicantFlg={onChangeApplicantFlg}
                        redFlg={redFlg}
                        familyFlg={familyFlg}
                    />
                    <div className="btnToConfirmWrapper">
                        <div class="confirmboxWrap">
                            <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                            <Button buttonText="確認画面へ" className="btnToConfirm btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                        </div>
                    </div>
                </>
            }
            <div className="backTopInputUser">
                <Link to={loginType === 'MEMBER' ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} style={styles.bottomLink}>ホテル検索TOPへ戻る</Link>
                <div style={temporaryErrorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={[temporaryErrorInfo.errorMessage]} />
                </div>
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        membershipSearchParam: state.membershipSearchParam,
        inputUserInfo: state.inputUserInfo,
        inputRoomList: state.inputRoomList,
        membershipReserveInfo: state.membershipReserveInfo,
        mealInfoList: state.mealInfoList,
        serviceCheckInfo: state.serviceCheckInfo,
        right: state.right,
        otherMenuInfoList: state.otherMenuInfoList,
        membershipReserveComf: state.membershipReserveComf,
        prevScreenInfo: state.prevScreenInfo,
        riyobiList: state.riyobiList
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
        setOtherMenuInfoList: (item) => {
            dispatch({ type: "OTHER_MENU_INFO_LIST", payload: { otherMenuInfoList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setInputRoomList: (item) => {
            dispatch({ type: "INPUT_ROOM_LIST", payload: { inputRoomList: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
        setRiyobiList: (item) => {
            dispatch({ type: "RIYOBI_LIST", payload: { riyobiList: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipInputUserContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}
